
// import React, { useState, useEffect, useRef } from "react";
// import { Modal, Button, Card, List, Input, Checkbox, message, Spin, Progress, Select, Radio, Tag, Tabs, Col, Row, Form,Typography,Badge } from "antd";
// import { DeleteOutlined, PlusOutlined, EditOutlined, MinusOutlined,CloseOutlined, InfoCircleOutlined, CheckOutlined, CheckCircleTwoTone, CloseCircleTwoTone, LoadingOutlined, SaveOutlined, PlusCircleOutlined } from "@ant-design/icons";
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// import { Editor } from "@tinymce/tinymce-react";
// import courseService from "../../services/course.service";
// import MatchingQuestion from "./MatchingQuestion";
// import TabPane from "antd/es/tabs/TabPane";
// import DragDropZones from "./quizes/DragDropZones";  // 🆕 AJOUTER

// const { TextArea } = Input;
// const { Title, Text } = Typography;

// const EvaluationsManager = ({ subjectId, courseId, showInPage = false }) => {
//   const editorRef = useRef(null);
//   // Helpers message centrés + durée
//   const notifyError = (content, duration = 8) =>
//     message.error({ content, duration, style: { marginTop: '20vh', textAlign: 'center' } });

//   const notifySuccess = (content, duration = 4) =>
//     message.success({ content, duration, style: { marginTop: '20vh', textAlign: 'center' } });
//   // Vérifie que le total tous types confondus ne dépasse pas 100 %
//   const ensureNotExceed100 = async ({ courseId, type, newValue, oldValue = 0 }) => {
//     const rows = await courseService.getTotalPourcentage(courseId);

//     const norm = (t) => (t || "").toLowerCase();
//     const isTotalRow = (t) => norm(t) === "total";

//     const sumOthers = (rows || [])
//       .filter((r) => !isTotalRow(r.type) && norm(r.type) !== norm(type))
//       .reduce((s, r) => s + Number(r.totalPourcentage || 0), 0);

//     const currentType = (rows || []).find((r) => norm(r.type) === norm(type));
//     const currentTypeTotal = Number(currentType?.totalPourcentage || 0);

//     const futureGlobal = sumOthers + (currentTypeTotal - Number(oldValue || 0) + Number(newValue || 0));

//     if (futureGlobal > 100) {
//       const dispo = Math.max(0, 100 - (sumOthers + currentTypeTotal - Number(oldValue || 0)));
//       notifyError(
//         `Le total global dépasserait 100 % (${futureGlobal.toFixed(2)} %). Il reste seulement ${dispo.toFixed(2)} % disponible.`
//       );
//       throw new Error("TOTAL_EXCEEDS_100");
//     }
//   };
//   const [editProgress, setEditProgress] = useState(0);
//   const [originalProgress, setOriginalProgress] = useState(0);

//   // --- Tous tes useState ici ---
//   const [quizzes, setQuizzes] = useState([]);
//   const [selectedQuiz, setSelectedQuiz] = useState(null);
//   const [questions, setQuestions] = useState([]);
//   const [selectedQuestion, setSelectedQuestion] = useState(null);
//   const [answers, setAnswers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [isQuizModalVisible, setIsQuizModalVisible] = useState(false);
//   const [newQuizTitle, setNewQuizTitle] = useState("");
//   const [newQuestionText, setNewQuestionText] = useState("");
//   const [newQuestionType, setNewQuestionType] = useState("QCU");
//   const [newAnswerText, setNewAnswerText] = useState("");
//   const [newQuestionExplanation, setNewQuestionExplanation] = useState("");
//   const [progressValues, setProgressValues] = useState({});
//   const [editQuizId, setEditQuizId] = useState(null);
//   const [editQuizTitle, setEditQuizTitle] = useState("");
//   const [attemptOnce, setAttemptOnce] = useState(false);
//   const [quizCountsInCertificate, setQuizCountsInCertificate] = useState({});
//   const [editQuestionId, setEditQuestionId] = useState(null);
//   const [editQuestionText, setEditQuestionText] = useState("");
//   const [editQuestionScore, setEditQuestionScore] = useState("");
//   const [editQuestionType, setEditQuestionType] = useState("");
//   const [loadingSaveQuestion, setLoadingSaveQuestion] = useState(false);
//   const [totalScore, setTotalScore] = useState(0);
//   const [leftText, setLeftText] = useState("");
//   const [rightText, setRightText] = useState("");
//   const [selectedElementType, setSelectedElementType] = useState("SUBJECT");
//   const [courseElements, setCourseElements] = useState([]); // éléments plats

//   const [editElementType, setEditElementType] = useState("SUBJECT");
//   const [editReferenceElementId, setEditReferenceElementId] = useState(null);
//   const [editPositioning, setEditPositioning] = useState(null);
// const [loadingAddZone, setLoadingAddZone] = useState(false);
// const [loadingAddProposition, setLoadingAddProposition] = useState(false);
// const [showMatchingAnswers, setShowMatchingAnswers] = useState(false);  // 🆕 AJOUTER ICI


//   const handleAddMatchingPair = async () => {
//     if (!leftText.trim() || !rightText.trim() || !selectedQuestion) return;

//     try {
//       const pair = await courseService.addMatchingPairToQuestion(selectedQuestion.id, {
//         leftText,
//         rightText
//       });
//       setAnswers([...answers, pair]);
//       setLeftText("");
//       setRightText("");
//       message.success("Paire ajoutée !");
//     } catch (error) {
//       console.error("Erreur API :", error.response?.data || error.message);
//       message.error("Erreur lors de l'ajout de la paire.");
//     }
//   };

//  const handleAddZone = async () => {
//   if (!leftText.trim() || !rightText.trim() || !selectedQuestion) return;

//   setLoadingAddZone(true);  // 🆕 AJOUTER
//   try {
//     await courseService.addZoneToQuestion(selectedQuestion.id, {
//       zoneLabel: leftText,
//       correctAnswer: rightText
//     });

//     message.success("Zone ajoutée !");
//     setLeftText("");
//     setRightText("");

//     const zones = await courseService.getZonesByQuestion(selectedQuestion.id);
//     const propositions = await courseService.getPropositionsByQuestion(selectedQuestion.id);

//     const combined = [
//       ...zones.map(z => ({ ...z, isZone: true })),
//       ...propositions.map(p => ({ ...p, isProposition: true }))
//     ];

//     setAnswers(combined);
//   } catch (error) {
//     message.error("Erreur lors de l'ajout de la zone.");
//   } finally {
//     setLoadingAddZone(false);  // 🆕 AJOUTER
//   }
// };

// const handleAddProposition = async () => {
//   if (!newAnswerText.trim() || !selectedQuestion) return;

//   setLoadingAddProposition(true);  // 🆕 AJOUTER
//   try {
//     await courseService.addPropositionToQuestion(selectedQuestion.id, {
//       content: newAnswerText
//     });

//     message.success("Proposition ajoutée !");
//     setNewAnswerText("");

//     const zones = await courseService.getZonesByQuestion(selectedQuestion.id);
//     const propositions = await courseService.getPropositionsByQuestion(selectedQuestion.id);

//     const combined = [
//       ...zones.map(z => ({ ...z, isZone: true })),
//       ...propositions.map(p => ({ ...p, isProposition: true }))
//     ];

//     setAnswers(combined);
//   } catch (error) {
//     message.error("Erreur lors de l'ajout de la proposition.");
//   } finally {
//     setLoadingAddProposition(false);  // 🆕 AJOUTER
//   }
// };


//   const fetchElementsByType = async (type) => {
//     if (type !== "SUBJECT") {
//       setCourseElements([]); // vider la liste si ce n'est pas un sujet
//       return;
//     }

//     try {
//       const elements = await courseService.Getgroupnames(courseId);
//       console.log("Groupes récupérés :", elements);
//       setCourseElements(Array.isArray(elements) ? elements : []);
//     } catch (err) {
//       message.error("Erreur chargement des groupes");
//     }
//   };

//   const handleEditQuestion = async () => {
//     if (!editQuestionText.trim() || !editQuestionId) return;

//     setLoadingSaveQuestion(true);

//     try {
//       await courseService.updateQuestion(editQuestionId, {
//         text: editQuestionText,
//         score: editQuestionScore,
//         questionType: editQuestionType,
//       });

//       message.success("Question mise à jour !");
//       setQuestions(questions.map(q =>
//         q.id === editQuestionId
//           ? { ...q, text: editQuestionText, score: editQuestionScore, questionType: editQuestionType }
//           : q
//       ));

//       setEditQuestionId(null);
//       setEditQuestionText("");
//       setEditQuestionScore("");
//       setEditQuestionType("");
//     } catch (error) {
//       message.error("Erreur lors de la mise à jour de la question.");
//     }

//     setLoadingSaveQuestion(false);
//   };




//   const handleQuizCheckboxChange = (quizId, checked) => {
//     setQuizCountsInCertificate(prev => ({
//       ...prev,
//       [quizId]: checked
//     }));
//   };


//   // useEffect(() => {
//   //   const fetchQuizzes = async () => {
//   //     try {
//   //       setLoading(true);
//   //       let response = [];

//   //       if (courseId) {
//   //         // 🔥 Nouvel appel pour cours
//   //         response = await courseService.getEvaluationByCourse(courseId);
//   //       } else if (subjectId) {
//   //         // 🔥 Sinon appel pour sujet
//   //         response = await courseService.getQuizzesBySubject(subjectId);
//   //       }

//   //       setQuizzes(response);
//   //     } catch (error) {
//   //       console.error("Erreur lors de la récupération des quizzes :", error);
//   //       message.error("Erreur lors de la récupération des quizzes.");
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   //   fetchQuizzes();
//   // }, [courseId, subjectId]);
// useEffect(() => {
//     const fetchQuizzes = async () => {
//         try {
//             setLoading(true);
//             let response = [];

//             if (courseId) {
//                 // 🚀 UTILISER LA NOUVELLE API OPTIMISÉE
//                 response = await courseService.getEvaluationsSummary(courseId);
//                 console.log("⚡ Évaluations chargées (optimisé):", response);
//             } else if (subjectId) {
//                 response = await courseService.getQuizzesBySubject(subjectId);
//             }

//             setQuizzes(response);
//         } catch (error) {
//             console.error("Erreur lors de la récupération des évaluations :", error);
//             message.error("Erreur lors de la récupération des évaluations.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     fetchQuizzes();
// }, [courseId, subjectId]);

//   useEffect(() => {
//     const total = questions.reduce((sum, q) => sum + (parseFloat(q.score) || 0), 0);
//     setTotalScore(total);
//   }, [questions]);


//   // --- Toutes tes fonctions (fetchQuizzes, handleSaveQuiz, etc) restent identiques ---
//   const handleSelectQuiz = async (quiz) => {
//     setSelectedQuiz(quiz);
//     try {
//       const response = await courseService.getQuestionsByQuiz(quiz.id);
//       setQuestions(response);
//       setSelectedQuestion(null);
//       setAnswers([]);
//     } catch (error) {
//       message.error("Erreur lors de la récupération des questions.");
//     }
//   };


//   const handleEditQuizClick = (quiz) => {
//     setEditQuizId(quiz.id);
//     setEditQuizTitle(quiz.title);
//     setAttemptOnce(quiz.attemptOnce || false);
//     setEditElementType(quiz.elementType || "SUBJECT");
//     setEditReferenceElementId(quiz.referenceElementId || null);
//     setEditPositioning(quiz.positioning || null);

//     const p = Number(quiz.progressPercentage || 0);
//     setEditProgress(p);
//     setOriginalProgress(p);

//     if (quiz.elementType === "SUBJECT") fetchElementsByType("SUBJECT");
//   };


//   const handleDeleteQuiz = async (quizId) => {
//     Modal.confirm({
//       title: "Êtes-vous sûr de vouloir supprimer ce quiz ?",
//       content: "Cette action est irréversible.",
//       okText: "Oui, supprimer",
//       okType: "danger",
//       cancelText: "Annuler",
//       onOk: async () => {
//         try {
//           await courseService.deleteQuiz(quizId);
//           message.success("Quiz supprimé !");
//           setQuizzes(quizzes.filter(q => q.id !== quizId));
//         } catch (error) {
//           message.error("Erreur lors de la suppression du quiz.");
//         }
//       },
//     });
//   };


//   const handleAddQuestion = async () => {
//     if (!newQuestionText.trim() || !selectedQuiz) return;
//     try {
//       const newQuestion = await courseService.addQuestionToQuiz(selectedQuiz.id, {
//         text: newQuestionText,
//         explanation: "",
//         questionType: newQuestionType,
//         quiz: { id: selectedQuiz.id },
//         score: 0
//       });

//       setQuestions([...questions, newQuestion]);
//       setNewQuestionText("");
//       message.success("Question ajoutée avec succès !");

//       // ✅ Si c'est une question de type VRAI_FAUX, ajouter deux réponses automatiquement
//       if (newQuestionType === "VRAI_FAUX") {
//         const trueAnswer = await courseService.addAnswerToQuestion(newQuestion.id, {
//           text: "Vrai",
//           isCorrect: false
//         });

//         const falseAnswer = await courseService.addAnswerToQuestion(newQuestion.id, {
//           text: "Faux",
//           isCorrect: false
//         });

//         setAnswers([trueAnswer, falseAnswer]);
//       }

//     } catch (error) {
//       message.error("Erreur lors de l'ajout de la question.");
//     }
//   };


//   const handleDeleteQuestion = async (questionId) => {
//     Modal.confirm({
//       title: "Êtes-vous sûr de vouloir supprimer cette question ?",
//       content: "Cette action est irréversible.",
//       okText: "Oui, supprimer",
//       okType: "danger",
//       cancelText: "Annuler",
//       onOk: async () => {
//         try {
//           await courseService.deleteQuestion(questionId);
//           message.success("Question supprimée !");
//           setQuestions(questions.filter(q => q.id !== questionId));
//           if (selectedQuestion?.id === questionId) {
//             setSelectedQuestion(null);
//             setAnswers([]);
//           }
//         } catch (error) {
//           message.error("Erreur lors de la suppression de la question.");
//         }
//       },
//     });
//   };



//   const handleAddQuiz = async () => {
//     try {
//       const values = await form.validateFields();

//       const payload = {
//         title: newQuizTitle,
//         attemptOnce,
//         referenceElementId: 0,
//         positioning: 0
//       };

//       console.log("📦 Payload envoyé à l'API de l'ajout de l'évaluation :", payload); // Affichage pour analyse

//       const newQuiz = await courseService.addEvaluationToCourse(courseId, payload);

//       message.success("Quiz ajouté avec succès !");
//       setQuizzes([...quizzes, newQuiz]);
//       setNewQuizTitle("");
//       setIsQuizModalVisible(false);
//       form.resetFields();
//     } catch (error) {
//       message.error("Erreur lors de l'ajout du quiz.");
//       console.error("❌ Erreur handleAddQuiz :", error);
//     }
//   };





//   const handleProgressChange = (quizId, value) => {
//     const numericValue = parseFloat(value.replace(",", "."));
//     if (!isNaN(numericValue)) {
//       setQuizzes(prev =>
//         prev.map(q => q.id === quizId ? { ...q, progressPercentage: numericValue } : q)
//       );
//     }
//   };


//   const handleDragEnd = (result) => {
//     if (!result.destination) return;
//     const reordered = Array.from(answers);
//     const [movedItem] = reordered.splice(result.source.index, 1);
//     reordered.splice(result.destination.index, 0, movedItem);
//     setAnswers(reordered);
//   };


//   // Valider et forcer entre 0 et 100
//   const handleProgressBlur = (quizId) => {
//     setQuizzes(prev =>
//       prev.map(q => {
//         if (q.id === quizId) {
//           const validated = Math.max(0, Math.min(100, parseFloat(q.progressPercentage) || 0));
//           return { ...q, progressPercentage: validated };
//         }
//         return q;
//       })
//     );
//   };

//   // Bouton +10%
//   const increaseProgress = (quizId) => {
//     setQuizzes(prev =>
//       prev.map(q => q.id === quizId ? { ...q, progressPercentage: Math.min(100, (q.progressPercentage || 0) + 10) } : q)
//     );
//   };

//   const handleValidateDragDropOrder = async () => {
//     if (!selectedQuestion) return;
//     try {
//       const orderedAnswerIds = answers.map(a => a.id);
//       await courseService.updateAnswersOrder(selectedQuestion.id, orderedAnswerIds);
//       message.success("Ordre des réponses sauvegardé !");
//     } catch (error) {
//       message.error("Erreur lors de la sauvegarde de l'ordre.");
//     }
//   };

//   // Bouton -10%
//   const decreaseProgress = (quizId) => {
//     setQuizzes(prev =>
//       prev.map(q => q.id === quizId ? { ...q, progressPercentage: Math.max(0, (q.progressPercentage || 0) - 10) } : q)
//     );
//   };

//   // const handleSelectQuestion = async (question) => {
//   //   setSelectedQuestion(question);
//   //   setNewQuestionExplanation(question.explanation || "");
//   //   try {
//   //     const response = await courseService.getAnswersByQuestion(question.id);
//   //     setAnswers(response);
//   //   } catch (error) {
//   //     message.error("Erreur lors de la récupération des réponses.");
//   //   }
//   // };

//   const handleSelectQuestion = async (question) => {
//     setSelectedQuestion(question);
//     setNewQuestionExplanation(question.explanation || "");
//     try {
//       if (question.questionType === "MATCHING") {
//         const response = await courseService.getMatchingPairsByQuestion(question.id);
//         setAnswers(response);
//         console.log("🎯 Matching pairs récupérées :", response);
//       } else if (question.questionType === "DRAG_DROP_ZONES") {
//         // 🆕 Charger zones ET propositions
//         const zones = await courseService.getZonesByQuestion(question.id);
//         const propositions = await courseService.getPropositionsByQuestion(question.id);

//         const combined = [
//           ...zones.map(z => ({ ...z, isZone: true })),
//           ...propositions.map(p => ({ ...p, isProposition: true }))
//         ];

//         setAnswers(combined);
//         console.log("✅ Zones et propositions chargées:", combined);
//       } else {
//         const response = await courseService.getAnswersByQuestion(question.id);
//         setAnswers(response);
//       }
//     } catch (error) {
//       message.error("Erreur lors de la récupération des réponses.");
//     }
//   };


//   const handleUpdateExplanation = async () => {
//     if (!selectedQuestion) return;
//     try {
//       await courseService.updateQuestionExplanation(selectedQuestion.id, newQuestionExplanation);
//       message.success("Explication mise à jour !");
//     } catch (error) {
//       message.error("Erreur lors de la mise à jour de l'explication.");
//     }
//   };

//   // const handleSaveQuiz = async (quizId) => {
//   //   if (!editQuizTitle.trim()) return;

//   //   try {
//   //     // await courseService.updateQuiz(quizId, {
//   //     //   title: editQuizTitle,
//   //     //   attemptOnce: attemptOnce, // Tentative unique
//   //     // });

//   //     await courseService.updateQuiz(quizId, {
//   //       title: editQuizTitle,
//   //       attemptOnce,
//   //       elementType: editElementType,
//   //       referenceElementId: editReferenceElementId,
//   //       positioning: editPositioning
//   //     });

//   //     message.success("Quiz mis à jour !");
//   //     setQuizzes(quizzes.map(q =>
//   //       q.id === quizId ? {
//   //         ...q,
//   //         title: editQuizTitle,
//   //         attemptOnce: attemptOnce
//   //       } : q
//   //     ));
//   //     setEditQuizId(null);
//   //     setEditQuizTitle("");
//   //   } catch (error) {
//   //     message.error("Erreur lors de la mise à jour du quiz.");
//   //   }
//   // };
//   // const handleSaveQuiz = async (quizId) => {
//   //   if (!editQuizTitle.trim()) return;

//   //   try {
//   //     // ✅ Récupération de la progression du quiz courant
//   //     const quizToUpdate = quizzes.find(q => q.id === quizId);
//   //     const progress = quizToUpdate?.progressPercentage || 0;

//   //     await courseService.updateQuiz(quizId, {
//   //       title: editQuizTitle,
//   //       attemptOnce,
//   //       elementType: editElementType,
//   //       referenceElementId: editReferenceElementId,
//   //       positioning: editPositioning,
//   //       progressPercentage: progress   // ✅ Ajout ici
//   //     });

//   //     message.success("Quiz mis à jour !");
//   //     setQuizzes(quizzes.map(q =>
//   //       q.id === quizId ? {
//   //         ...q,
//   //         title: editQuizTitle,
//   //         attemptOnce,
//   //         progressPercentage: progress
//   //       } : q
//   //     ));
//   //     setEditQuizId(null);
//   //     setEditQuizTitle("");
//   //   } catch (error) {
//   //     message.error("Erreur lors de la mise à jour du quiz.");
//   //   }
//   // };


//   const handleSaveQuiz = async (quizId) => {
//     if (!editQuizTitle.trim()) return;

//     try {
//       await ensureNotExceed100({
//         courseId,
//         type: "evaluation",            // ⬅️ ICI : évaluation
//         newValue: editProgress,
//         oldValue: originalProgress,
//       });

//       await courseService.updateQuiz(quizId, {
//         title: editQuizTitle,
//         attemptOnce,
//         elementType: editElementType,
//         referenceElementId: editReferenceElementId,
//         positioning: editPositioning,
//         progressPercentage: editProgress,
//       });

//       notifySuccess("Évaluation mise à jour !");
//       setQuizzes(qs => qs.map(q =>
//         q.id === quizId ? { ...q, title: editQuizTitle, attemptOnce, progressPercentage: editProgress } : q
//       ));
//       setEditQuizId(null);
//       setEditQuizTitle("");
//     } catch (err) {
//       if (err?.message !== "TOTAL_EXCEEDS_100") notifyError("Erreur lors de la mise à jour de l'évaluation.");
//     }
//   };


//   const handleAddAnswer = async () => {
//     if (!newAnswerText.trim() || !selectedQuestion) return;

//     try {
//       const newAnswer = { text: newAnswerText, isCorrect: false }; // Toujours faux au départ
//       const savedAnswer = await courseService.addAnswerToQuestion(selectedQuestion.id, newAnswer);

//       setAnswers([...answers, savedAnswer]);
//       setNewAnswerText("");
//       message.success("Réponse ajoutée !");
//     } catch (error) {
//       message.error("Erreur lors de l'ajout de la réponse.");
//     }
//   };

//   const handleSelectCorrectAnswer = async (selectedId) => {
//     if (!selectedQuestion) return;

//     let updatedAnswers;

//     if (selectedQuestion.questionType === "QCU" || selectedQuestion.questionType === "VRAI_FAUX") {
//       updatedAnswers = answers.map(a => ({
//         ...a,
//         isCorrect: a.id === selectedId
//       }));
//     } else if (selectedQuestion.questionType === "QCM") {
//       updatedAnswers = answers.map(a =>
//         a.id === selectedId ? { ...a, isCorrect: !a.isCorrect } : a
//       );
//     }

//     setAnswers(updatedAnswers);

//     try {
//       const correctAnswerIds = updatedAnswers.filter(a => a.isCorrect).map(a => a.id);
//       await courseService.updateCorrectAnswers(selectedQuestion.id, correctAnswerIds);
//       message.success("Réponses mises à jour !");
//     } catch (error) {
//       message.error("Erreur lors de la mise à jour des réponses correctes.");
//     }
//   };

//   const renderAnswerInput = () => {
//     if (!selectedQuestion) return null;

//     switch (selectedQuestion.questionType) {
//       case "QCU":
//         return (
//           <Radio.Group
//             value={answers.find(a => a.isCorrect)?.id}
//             onChange={(e) => handleSelectCorrectAnswer(e.target.value)}
//           >
//             {answers.map(answer => (
//               <Radio key={answer.id} value={answer.id}>
//                 {answer.text}
//               </Radio>
//             ))}
//           </Radio.Group>
//         );

//       case "QCM":
//         return (
//           <Checkbox.Group
//             value={answers.filter(a => a.isCorrect).map(a => a.id)}
//             // onChange={(checkedValues) => {
//             //   checkedValues.forEach(id => handleSelectCorrectAnswer(id));
//             // }}
//             onChange={(checkedValues) => {
//               const updatedAnswers = answers.map((a) => ({
//                 ...a,
//                 isCorrect: checkedValues.includes(a.id),
//               }));
//               setAnswers(updatedAnswers);

//               const correctAnswerIds = updatedAnswers.filter(a => a.isCorrect).map(a => a.id);

//               // Appel unique à l'API
//               courseService.updateCorrectAnswers(selectedQuestion.id, correctAnswerIds)
//                 .then(() => {
//                   message.success("Réponses mises à jour !");
//                 })
//                 .catch(() => {
//                   message.error("Erreur lors de la mise à jour des réponses correctes.");
//                 });
//             }}

//           >
//             {answers.map(answer => (
//               <Checkbox key={answer.id} value={answer.id}>
//                 {answer.text}
//               </Checkbox>
//             ))}
//           </Checkbox.Group>
//         );

//       case "VRAI_FAUX":
//         return (
//           <Radio.Group
//             value={answers.find(a => a.isCorrect)?.id}
//             onChange={(e) => handleSelectCorrectAnswer(e.target.value)}
//           >
//             {answers.map(answer => (
//               <Radio key={answer.id} value={answer.id}>
//                 {answer.text}
//               </Radio>
//             ))}
//           </Radio.Group>
//         );

//       case "DRAG_DROP":
//         return (
//           <>
//             <DragDropContext onDragEnd={handleDragEnd}>
//               <Droppable droppableId="answers-list">
//                 {(provided) => (
//                   <div ref={provided.innerRef} {...provided.droppableProps} style={{ padding: 10, background: "#f8f9fa", borderRadius: 5 }}>
//                     {answers.map((answer, index) => (
//                       <Draggable key={String(answer.id)} draggableId={String(answer.id)} index={index}>
//                         {(provided) => (
//                           <div
//                             ref={provided.innerRef}
//                             {...provided.draggableProps}
//                             {...provided.dragHandleProps}
//                             style={{
//                               padding: 10,
//                               margin: "5px 0",
//                               background: "#ffffff",
//                               border: "1px solid #ddd",
//                               borderRadius: 5,
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "space-between",
//                               ...provided.draggableProps.style,
//                             }}
//                           >
//                             {answer.text}
//                           </div>
//                         )}
//                       </Draggable>
//                     ))}
//                     {provided.placeholder}
//                   </div>
//                 )}
//               </Droppable>
//             </DragDropContext>

//             {/* 🔵 Bouton pour valider l'ordre */}
//             <Button
//               type="primary"
//               style={{ marginTop: "10px" }}
//               onClick={handleValidateDragDropOrder}
//             >
//               Valider l'ordre des réponses
//             </Button>
//           </>
//         );


//       case "MATCHING":
//         return (
//           <div>
//             {/* 🟦 Interface visuelle de l'appariement */}
//             <MatchingQuestion
//               pairs={answers.map(a => ({
//                 id: a.id,
//                 leftText: a.leftText,
//                 rightText: a.rightText,
//               }))}
//             />


//             {/* 🟨 Inputs pour ajouter une nouvelle paire */}
//             <div style={{ display: 'flex', marginTop: 20, gap: 10 }}>
//               <Input
//                 placeholder="Texte gauche"
//                 value={leftText}
//                 onChange={(e) => setLeftText(e.target.value)}
//               />
//               <Input
//                 placeholder="Texte droit"
//                 value={rightText}
//                 onChange={(e) => setRightText(e.target.value)}
//               />
//               <Button type="primary" icon={<PlusOutlined />} onClick={handleAddMatchingPair}>
//                 Ajouter la paire
//               </Button>
//             </div>
//           </div>
//         );

//       case "DRAG_DROP_ZONES":
//   return (
//     <div style={{ 
//       padding: '16px', 
//       background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', 
//       borderRadius: '8px',
//       border: '1px solid #dee2e6'
//     }}>
//       {/* En-tête */}
//       <div style={{ 
//         display: 'flex', 
//         alignItems: 'center', 
//         gap: '10px',
//         marginBottom: '16px',
//         padding: '12px',
//         background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//         borderRadius: '8px',
//         boxShadow: '0 2px 8px rgba(25, 118, 210, 0.2)'
//       }}>
//         <div style={{
//           background: 'white',
//           borderRadius: '50%',
//           width: '36px',
//           height: '36px',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           fontSize: '18px'
//         }}>
//           🎯
//         </div>
//         <div style={{ flex: 1 }}>
//           <Title level={5} style={{ 
//             margin: 0, 
//             color: 'white', 
//             fontSize: '14px',
//             fontWeight: '600'
//           }}>
//             Zones à remplir par Glisser-Déposer
//           </Title>
//           <Text style={{ 
//             color: 'rgba(255, 255, 255, 0.9)', 
//             fontSize: '12px',
//             display: 'block',
//             marginTop: '2px'
//           }}>
//             Gérez vos zones et testez l'exercice
//           </Text>
//         </div>
//       </div>

//       {/* TABS POUR SÉPARER GESTION ET TEST */}
//       <Tabs defaultActiveKey="1" size="small">
//         {/* ONGLET 1 : GESTION */}
//         <TabPane 
//           tab={
//             <span style={{ fontSize: '13px', fontWeight: '600' }}>
//               ⚙️ Gestion
//             </span>
//           } 
//           key="1"
//         >
//           <div style={{ padding: '12px 0' }}>
//             {/* ÉTAPE 1 : Propositions */}
//             <div style={{
//               background: 'white',
//               borderRadius: '8px',
//               padding: '16px',
//               marginBottom: '16px',
//               boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
//               border: '1px solid #e8e8e8'
//             }}>
//               <div style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '8px',
//                 marginBottom: '12px',
//                 paddingBottom: '10px',
//                 borderBottom: '2px solid #f0f0f0'
//               }}>
//                 <div style={{
//                   background: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
//                   borderRadius: '6px',
//                   width: '28px',
//                   height: '28px',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontSize: '14px'
//                 }}>
//                   🎲
//                 </div>
//                 <div style={{ flex: 1 }}>
//                   <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                     <Title level={5} style={{ 
//                       margin: 0, 
//                       fontSize: '13px',
//                       color: '#52c41a',
//                       fontWeight: '600'
//                     }}>
//                       Étape 1 : Ajouter les propositions disponibles
//                     </Title>
//                     <Badge 
//                       count={answers.filter(a => a.propositionContent).length} 
//                       style={{ backgroundColor: '#52c41a', fontSize: '10px' }} 
//                     />
//                   </div>
//                   <Text style={{ 
//                     fontSize: '11px', 
//                     color: '#999',
//                     display: 'block',
//                     marginTop: '2px'
//                   }}>
//                     Toutes les options que l'apprenant pourra glisser
//                   </Text>
//                 </div>
//               </div>

//               {/* Liste des propositions */}
//               {answers.filter(a => a.propositionContent).length > 0 && (
//                 <div style={{ 
//                   marginBottom: '12px',
//                   padding: '10px',
//                   background: '#f8f9fa',
//                   borderRadius: '6px'
//                 }}>
//                   <Text strong style={{ fontSize: '11px', color: '#666', display: 'block', marginBottom: '8px' }}>
//                     Propositions créées :
//                   </Text>
//                   <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
//                     {answers
//                       .filter(a => a.propositionContent)
//                       .map(prop => (
//                         <Tag 
//                           key={prop.id}
//                           color="green"
//                           style={{ 
//                             fontSize: '12px',
//                             padding: '4px 10px',
//                             borderRadius: '4px'
//                           }}
//                         >
//                           💡 {prop.propositionContent}
//                         </Tag>
//                       ))}
//                   </div>
//                 </div>
//               )}

//               {/* Formulaire ajout proposition */}
//               <Row gutter={10}>
//                 <Col span={16}>
//                   <div style={{ marginBottom: '6px' }}>
//                     <Text strong style={{ fontSize: '11px', color: '#666' }}>
//                       Contenu de la proposition
//                     </Text>
//                   </div>
//                   <Input
//                     prefix={<span style={{ fontSize: '14px' }}>💡</span>}
//                     placeholder="Ex: SAP S/4HANA Cloud, Monitoring..."
//                     value={newAnswerText}
//                     onChange={(e) => setNewAnswerText(e.target.value)}
//                     size="middle"
//                     style={{
//                       borderRadius: '6px',
//                       fontSize: '13px'
//                     }}
//                   />
//                 </Col>
//                 <Col span={8}>
//                   <div style={{ marginBottom: '6px', opacity: 0 }}>
//                     <Text>.</Text>
//                   </div>
//                   <Button
//                     type="primary"
//                     icon={<PlusOutlined />}
//                     onClick={handleAddProposition}
//                       loading={loadingAddProposition}  // 🆕 AJOUTER CETTE LIGNE

//                     size="middle"
//                     style={{ 
//                       width: '100%',
//                       height: '32px',
//                       borderRadius: '6px',
//                       fontSize: '13px',
//                       fontWeight: '600',
//                       background: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
//                       border: 'none',
//                       boxShadow: '0 2px 6px rgba(82, 196, 26, 0.3)'
//                     }}
//                   >
//                     Ajouter
//                   </Button>
//                 </Col>
//               </Row>
//             </div>

//             {/* ÉTAPE 2 : Zones */}
//             <div style={{
//               background: 'white',
//               borderRadius: '8px',
//               padding: '16px',
//               boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
//               border: '1px solid #e8e8e8',
//               opacity: answers.filter(a => a.propositionContent).length === 0 ? 0.6 : 1,
//               pointerEvents: answers.filter(a => a.propositionContent).length === 0 ? 'none' : 'auto'
//             }}>
//               <div style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '8px',
//                 marginBottom: '12px',
//                 paddingBottom: '10px',
//                 borderBottom: '2px solid #f0f0f0'
//               }}>
//                 <div style={{
//                   background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//                   borderRadius: '6px',
//                   width: '28px',
//                   height: '28px',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontSize: '14px'
//                 }}>
//                   📍
//                 </div>
//                 <div style={{ flex: 1 }}>
//                   <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                     <Title level={5} style={{ 
//                       margin: 0, 
//                       fontSize: '13px',
//                       color: '#1976d2',
//                       fontWeight: '600'
//                     }}>
//                       Étape 2 : Définir les zones à remplir
//                     </Title>
//                     <Badge 
//                       count={answers.filter(a => a.zoneLabel).length} 
//                       style={{ backgroundColor: '#1976d2', fontSize: '10px' }} 
//                     />
//                   </div>
//                   <Text style={{ 
//                     fontSize: '11px', 
//                     color: '#999',
//                     display: 'block',
//                     marginTop: '2px'
//                   }}>
//                     Créez une zone et sélectionnez la bonne réponse
//                   </Text>
//                 </div>
//               </div>

//               {answers.filter(a => a.propositionContent).length === 0 && (
//                 <div style={{
//                   padding: '12px',
//                   background: '#fff7e6',
//                   border: '1px solid #ffd591',
//                   borderRadius: '6px',
//                   marginBottom: '12px',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '8px'
//                 }}>
//                   <InfoCircleOutlined style={{ color: '#fa8c16', fontSize: '16px' }} />
//                   <Text style={{ fontSize: '12px', color: '#d46b08' }}>
//                     Veuillez d'abord créer au moins une proposition
//                   </Text>
//                 </div>
//               )}

//               {/* Liste des zones */}
//               {answers.filter(a => a.zoneLabel).length > 0 && (
//                 <div style={{ 
//                   marginBottom: '12px',
//                   padding: '10px',
//                   background: '#f8f9fa',
//                   borderRadius: '6px'
//                 }}>
//                   <Text strong style={{ fontSize: '11px', color: '#666', display: 'block', marginBottom: '8px' }}>
//                     Zones créées :
//                   </Text>
//                   <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
//                     {answers
//                       .filter(a => a.zoneLabel)
//                       .map(zone => (
//                         <div 
//                           key={zone.id}
//                           style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '8px',
//                             padding: '6px 10px',
//                             background: 'white',
//                             borderRadius: '4px',
//                             border: '1px solid #e8e8e8'
//                           }}
//                         >
//                           <Tag color="blue" style={{ margin: 0, fontSize: '11px' }}>
//                             📍 {zone.zoneLabel}
//                           </Tag>
//                           <span style={{ fontSize: '11px', color: '#999' }}>→</span>
//                           <Tag color="green" style={{ margin: 0, fontSize: '11px' }}>
//                             ✓ {zone.correctAnswer}
//                           </Tag>
//                         </div>
//                       ))}
//                   </div>
//                 </div>
//               )}

//               {/* Formulaire ajout zone */}
//               <Row gutter={10}>
//                 <Col span={8}>
//                   <div style={{ marginBottom: '6px' }}>
//                     <Text strong style={{ fontSize: '11px', color: '#666' }}>
//                       Label de la zone
//                     </Text>
//                   </div>
//                   <Input
//                     prefix={<span style={{ fontSize: '14px' }}>🏷️</span>}
//                     placeholder="Ex: Phase de Découverte"
//                     value={leftText}
//                     onChange={(e) => setLeftText(e.target.value)}
//                     size="middle"
//                     style={{
//                       borderRadius: '6px',
//                       fontSize: '13px'
//                     }}
//                   />
//                 </Col>
//                 <Col span={12}>
//                   <div style={{ marginBottom: '6px' }}>
//                     <Text strong style={{ fontSize: '11px', color: '#666' }}>
//                       Réponse correcte
//                     </Text>
//                   </div>
//                   <Select
//                     placeholder="Choisir la bonne réponse"
//                     value={rightText}
//                     onChange={(value) => setRightText(value)}
//                     size="middle"
//                     style={{
//                       width: '100%',
//                       borderRadius: '6px',
//                       fontSize: '13px'
//                     }}
//                     suffixIcon={<span style={{ fontSize: '14px' }}>✓</span>}
//                   >
//                     {answers
//                       .filter(a => a.propositionContent)
//                       .map(prop => (
//                         <Select.Option key={prop.id} value={prop.propositionContent}>
//                           💡 {prop.propositionContent}
//                         </Select.Option>
//                       ))}
//                   </Select>
//                 </Col>
//                 <Col span={4}>
//                   <div style={{ marginBottom: '6px', opacity: 0 }}>
//                     <Text>.</Text>
//                   </div>
//                   <Button
//                     type="primary"
//                     icon={<PlusOutlined />}
//                       loading={loadingAddZone}  // 🆕 AJOUTER CETTE LIGNE

//                     onClick={handleAddZone}
//                     disabled={answers.filter(a => a.propositionContent).length === 0}
//                     size="middle"
//                     style={{ 
//                       width: '100%',
//                       height: '32px',
//                       borderRadius: '6px',
//                       fontSize: '13px',
//                       fontWeight: '600',
//                       background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//                       border: 'none',
//                       boxShadow: '0 2px 6px rgba(25, 118, 210, 0.3)'
//                     }}
//                   >
//                     Créer
//                   </Button>
//                 </Col>
//               </Row>
//             </div>

//             {/* Info helper */}
//             <div style={{
//               marginTop: '16px',
//               padding: '12px',
//               background: 'rgba(25, 118, 210, 0.08)',
//               borderRadius: '6px',
//               border: '1px solid rgba(25, 118, 210, 0.2)',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '10px'
//             }}>
//               <InfoCircleOutlined style={{ 
//                 fontSize: '16px', 
//                 color: '#1976d2',
//                 flexShrink: 0
//               }} />
//               <Text style={{ fontSize: '12px', color: '#1976d2', lineHeight: '1.5' }}>
//                 <strong>Mode d'emploi :</strong> (1) Créez vos propositions, 
//                 (2) Créez les zones et associez-les aux bonnes réponses.
//               </Text>
//             </div>
//           </div>
//         </TabPane>

//         {/* ONGLET 2 : TEST */}
//         <TabPane 
//           tab={
//             <span style={{ fontSize: '13px', fontWeight: '600' }}>
//               🎮 Test Interactif
//             </span>
//           } 
//           key="2"
//         >
//           <div style={{ padding: '12px 0' }}>
//             {answers.length > 0 ? (
//               <div style={{
//                 background: 'white',
//                 borderRadius: '8px',
//                 padding: '16px',
//                 boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
//                 border: '1px solid #e8e8e8'
//               }}>
//                 <DragDropZones
//                   zones={answers
//                     .filter(a => a.zoneLabel)
//                     .map(a => ({
//                       id: a.id,
//                       label: a.zoneLabel,
//                       correctAnswer: a.correctAnswer,
//                     }))}
//                   propositions={answers
//                     .filter(a => a.propositionContent)
//                     .map(a => ({
//                       id: a.id,
//                       content: a.propositionContent,
//                     }))}
//                   onAnswerChange={(answer) => {
//                     console.log('Zone remplie:', answer);
//                   }}
// showCorrectAnswers={showMatchingAnswers}  // 🆕 CHANGER ICI
//                 />

//                 {/* Bouton de vérification */}
//                 <div style={{
//                   display: 'flex',
//                   justifyContent: 'center',
//                   marginTop: '16px',
//                   gap: '8px'
//                 }}>
//                  <Button
//   type={showMatchingAnswers ? "default" : "primary"}  // 🆕 CHANGER
//   icon={showMatchingAnswers ? <CloseOutlined /> : <CheckOutlined />}  // 🆕 CHANGER
//   onClick={() => setShowMatchingAnswers(!showMatchingAnswers)}  // 🆕 AJOUTER
//   size="middle"
//   style={{
//     height: '36px',
//     borderRadius: '8px',
//     fontSize: '13px',
//     fontWeight: '600',
//     boxShadow: showMatchingAnswers ? 'none' : '0 2px 8px rgba(82, 196, 26, 0.3)',  // 🆕 CHANGER
//     background: showMatchingAnswers ? undefined : 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',  // 🆕 CHANGER
//     border: 'none'
//   }}
// >
//   {showMatchingAnswers ? "❌ Masquer les réponses" : "✅ Vérifier les réponses"}  {/* 🆕 CHANGER */}
// </Button>
//                 </div>
//               </div>
//             ) : (
//               <div style={{
//                 padding: '48px',
//                 textAlign: 'center',
//                 background: 'white',
//                 borderRadius: '8px',
//                 border: '2px dashed #d9d9d9'
//               }}>
//                 <div style={{
//                   fontSize: '64px',
//                   marginBottom: '16px',
//                   opacity: 0.5
//                 }}>
//                   🎯
//                 </div>
//                 <Title level={5} style={{ 
//                   color: '#999', 
//                   fontSize: '14px',
//                   marginBottom: '8px'
//                 }}>
//                   Aucune zone configurée
//                 </Title>
//                 <Text style={{ 
//                   color: '#bbb', 
//                   fontSize: '12px'
//                 }}>
//                   Passez à l'onglet "Gestion" pour créer vos zones et propositions
//                 </Text>
//               </div>
//             )}
//           </div>
//         </TabPane>
//       </Tabs>
//     </div>
//   );
      
//         default:
//         return <div>Aucune réponse disponible pour ce type.</div>;
//     }
//   };



//   // 🔵 Nouvelle fonction pour rendre tout le contenu principal sans modal
//   const renderControleConnaissanceManagement = () => (
//     <div style={{ display: "flex", gap: "20px" }}>
//       <Card title="Liste des evalations" style={{ width: "40%", backgroundColor: "#f8f9fa" }}>
//         {loading ? <Spin indicator={<LoadingOutlined />} /> : null}
//         <div style={{ marginBottom: "20px" }}>
//           <Button
//             type="primary"
//             icon={<PlusCircleOutlined />}
//             onClick={() => setIsQuizModalVisible(true)}
//             disabled={quizzes.length >= 1}   // ✅ Désactivation si une évaluation existe déjà

//           >
//             Ajouter une évaluation
//           </Button>

//           <Modal
//             title=""
//             open={isQuizModalVisible}
//             onCancel={() => setIsQuizModalVisible(false)}
//             onOk={async () => {
//               try {
//                 const values = await form.validateFields();
//                 console.log("✅ Valeurs du formulaire :", {
//                   ...values,
//                   title: newQuizTitle,
//                   attemptOnce
//                 });

//                 // Ton ancienne logique ici si nécessaire
//                 await handleAddQuiz(); // ou passe les valeurs directement
//               } catch (error) {
//                 console.log("❌ Erreur validation formulaire :", error);
//               }
//             }}
//             okText="Ajouter"
//             cancelText="Annuler"
//           >
//             <Form form={form} layout="vertical">
//               <Row gutter={24}>
//                 <Col span={24}>
//                   <Input
//                     placeholder="Titre du l'évaluation"
//                     value={newQuizTitle}
//                     onChange={(e) => setNewQuizTitle(e.target.value)}
//                   />
//                 </Col>


//               </Row>
//             </Form>

//             <Checkbox
//               checked={attemptOnce}
//               onChange={(e) => setAttemptOnce(e.target.checked)}
//               style={{ marginTop: 10 }}
//             >
//               Tentative unique ?
//             </Checkbox>
//           </Modal>


//         </div>

//         <List
//           dataSource={quizzes}
//           renderItem={(quiz) => (
//             <List.Item
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 width: "100%",
//               }}
//             >
//               {editQuizId === quiz.id ? (
//                 <div
//                   style={{
//                     border: "2px solid #91d5ff",
//                     borderRadius: "12px",
//                     backgroundColor: "#e6f7ff",
//                     padding: "24px",
//                     marginTop: 16,
//                     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)",
//                   }}
//                 >
//                   <h2 style={{ color: "#1890ff", marginBottom: 24, display: "flex", alignItems: "center", gap: 8 }}>
//                     <EditOutlined />
//                     Modifier le Quiz
//                   </h2>

//                   <Row gutter={32}>
//                     <Col span={12} style={{ borderRight: "1px solid #d9d9d9", paddingRight: 16 }}>
//                       <Form layout="vertical">
//                         <Form.Item label="Titre du Quiz">
//                           <Input
//                             value={editQuizTitle}
//                             onChange={(e) => setEditQuizTitle(e.target.value)}
//                             placeholder="Titre du Quiz"
//                           />
//                         </Form.Item>

//                         <Form.Item label="Tentative unique">
//                           <Checkbox
//                             checked={attemptOnce}
//                             onChange={(e) => setAttemptOnce(e.target.checked)}
//                           >
//                             Le quiz ne peut être tenté qu’une seule fois
//                           </Checkbox>
//                         </Form.Item>

//                         <Form.Item label="Progression (en %)">
//                           <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//                             <Button icon={<MinusOutlined />} onClick={() => setEditProgress(v => Math.max(0, (v || 0) - 5))} />
//                             <Progress type="circle" percent={editProgress || 0} width={60} />
//                             <Button icon={<PlusOutlined />} onClick={() => setEditProgress(v => Math.min(100, (v || 0) + 5))} />
//                           </div>
//                           <Input
//                             type="number"
//                             value={editProgress}
//                             onChange={(e) => setEditProgress(Math.max(0, Math.min(100, Number(e.target.value) || 0)))}
//                             min={0}
//                             max={100}
//                             style={{ marginTop: 10 }}
//                             suffix="%"
//                           />
//                         </Form.Item>


//                       </Form>
//                     </Col>

//                     <Col span={12} style={{ paddingLeft: 16 }}>
//                       <Form layout="vertical">
//                         <Form.Item label="Type d’élément">
//                           <Select
//                             value={editElementType}
//                             onChange={(val) => {
//                               setEditElementType(val);
//                               setEditReferenceElementId(null);
//                               if (val === "SUBJECT") fetchElementsByType(val);
//                             }}
//                           >
//                             <Select.Option value="SUBJECT">Sujet</Select.Option>
//                             <Select.Option value="TRAINING">Entraînement</Select.Option>
//                           </Select>
//                         </Form.Item>

//                         <Form.Item label="Insérer par rapport à l’élément">
//                           <Select
//                             value={editReferenceElementId}
//                             onChange={(val) => setEditReferenceElementId(val)}
//                             disabled={editElementType !== "SUBJECT"}
//                             placeholder="Choisir un élément"
//                           >
//                             {courseElements.map(el => (
//                               <Select.Option key={el.referenceId} value={el.referenceId}>
//                                 {el.label}
//                               </Select.Option>
//                             ))}
//                           </Select>
//                         </Form.Item>

//                         <Form.Item label="Positionner">
//                           <Select
//                             value={editPositioning}
//                             onChange={(val) => setEditPositioning(val)}
//                             placeholder="Avant ou Après"
//                           >
//                             <Select.Option value="BEFORE">Avant</Select.Option>
//                             <Select.Option value="AFTER">Après</Select.Option>
//                           </Select>
//                         </Form.Item>
//                       </Form>
//                     </Col>
//                   </Row>

//                   <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 24, gap: 12 }}>
//                     <Button type="primary" icon={<SaveOutlined />} onClick={() => handleSaveQuiz(quiz.id)}>
//                       Enregistrer
//                     </Button>
//                     <Button danger onClick={() => setEditQuizId(null)}>
//                       Annuler
//                     </Button>
//                   </div>
//                 </div>

//               ) : (
//                 <>
//                   <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                     <span>{quiz.title} ({quiz.progressPercentage}%)</span>
//                     {quiz.attemptOnce && (
//                       <Tag color="red">Tentative unique</Tag>
//                     )}
//                   </div>

//                   <div>
//                     <Button type="link" onClick={() => handleSelectQuiz(quiz)}>Sélectionner</Button>
//                     <Button type="link" icon={<EditOutlined />} onClick={() => handleEditQuizClick(quiz)} />
//                     <Button type="link" danger icon={<DeleteOutlined />} onClick={() => handleDeleteQuiz(quiz.id)} />
//                   </div>
//                 </>
//               )}
//             </List.Item>
//           )}
//         />

//       </Card>

//       {selectedQuiz && (
//         <div style={{ display: "flex", flexDirection: "column", width: "65%", gap: "20px" }}>
//           <Card
//             title={
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                 <span>Questions du Quiz : {selectedQuiz.title}</span>
//                 <span style={{ fontWeight: "bold", color: "#52c41a" }}>
//                   Total Score : {totalScore}
//                 </span>
//               </div>
//             }
//             style={{ backgroundColor: "#e3f2fd" }}
//           >

//             {/* Zone d'ajout de question */}
//             <Input
//               placeholder="Nouvelle question"
//               value={newQuestionText}
//               onChange={(e) => setNewQuestionText(e.target.value)}
//               style={{ marginBottom: 10 }}
//             />

//             <Select
//               style={{ width: "100%", marginBottom: 10 }}
//               value={newQuestionType}
//               onChange={(value) => setNewQuestionType(value)}
//             >
//               <Select.Option value="QCU">Choix Unique</Select.Option>
//               <Select.Option value="QCM">Choix Multiple</Select.Option>
//               {/* <Select.Option value="DRAG_DROP">Drag & Drop</Select.Option> */}
//               <Select.Option value="VRAI_FAUX">Vrai / Faux</Select.Option>
//               {/* <Select.Option value="MATCHING">Appariement (Matching)</Select.Option> */}
//               <Select.Option value="DRAG_DROP_ZONES">Zones à remplir</Select.Option>

//             </Select>

//             <Button type="primary" icon={<PlusOutlined />} onClick={handleAddQuestion}>
//               Ajouter une Question
//             </Button>


//             {/* Liste des questions */}
//             <List
//               dataSource={questions}
//               renderItem={(question) => (
//                 <List.Item
//                   style={{
//                     backgroundColor: selectedQuestion?.id === question.id ? "#d3f9d8" : "#e3f2fd",
//                     marginTop: 10,
//                     padding: 10,
//                     borderRadius: 8,
//                   }}
//                   onClick={() => handleSelectQuestion(question)}
//                 >
//                   {editQuestionId === question.id ? (
//                     <div style={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%" }}>
//                       <Input
//                         value={editQuestionText}
//                         onChange={(e) => setEditQuestionText(e.target.value)}
//                         placeholder="Texte de la question"
//                       />
//                       <Select
//                         value={editQuestionType}
//                         onChange={(value) => setEditQuestionType(value)}
//                         placeholder="Type de question"
//                       >
//                         <Select.Option value="QCU">Choix Unique</Select.Option>
//                         <Select.Option value="QCM">Choix Multiple</Select.Option>
//                         {/* <Select.Option value="DRAG_DROP">Drag & Drop</Select.Option> */}
//                         <Select.Option value="VRAI_FAUX">Vrai / Faux</Select.Option>
//                         {/* <Select.Option value="MATCHING">Appariement</Select.Option> */}
//                         <Select.Option value="DRAG_DROP_ZONES">Zones à remplir</Select.Option>

//                       </Select>
//                       <Input
//                         type="number"
//                         value={editQuestionScore}
//                         onChange={(e) => setEditQuestionScore(e.target.value)}
//                         placeholder="Score"
//                       />

//                       <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
//                         <Button type="primary" onClick={handleEditQuestion} loading={loadingSaveQuestion}>
//                           Enregistrer
//                         </Button>
//                         <Button danger onClick={() => setEditQuestionId(null)}>
//                           Annuler
//                         </Button>
//                       </div>
//                     </div>
//                   ) : (
//                     <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
//                       <div>
//                         {question.text} ({question.questionType}) - Score: {question.score ?? 0}
//                       </div>
//                       <div style={{ display: "flex", gap: "10px" }}>
//                         <Button
//                           icon={<EditOutlined />}
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             setEditQuestionId(question.id);
//                             setEditQuestionText(question.text);
//                             setEditQuestionScore(question.score ?? 0);
//                             setEditQuestionType(question.questionType);
//                           }}
//                         />
//                         <Button
//                           icon={<DeleteOutlined />}
//                           danger
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             handleDeleteQuestion(question.id);
//                           }}
//                         />
//                       </div>
//                     </div>
//                   )}
//                 </List.Item>
//               )}
//             />

//           </Card>

//           {selectedQuestion && (
//             <>
//               {/* Explication */}
//               <Card title={`Explication pour : ${selectedQuestion.text}`} style={{ backgroundColor: "#e8f5e9" }}>
//                 <Editor
//                   apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
//                   value={newQuestionExplanation}
//                   onEditorChange={(content) => setNewQuestionExplanation(content)}
//                   init={{
//                     height: 300,
//                     menubar: true,
//                     plugins: "link image media table code help wordcount",
//                     toolbar: "undo redo | bold italic underline | link image | alignleft aligncenter alignright | code",
//                   }}
//                 />
//                 <Button type="primary" onClick={handleUpdateExplanation} style={{ marginTop: 10 }}>
//                   Enregistrer Explication
//                 </Button>
//               </Card>

//               {/* Réponses */}
//               <Card title={`Réponses pour : ${selectedQuestion.text}`} style={{ backgroundColor: "#fff3cd" }}>
//                 {/* Afficher les réponses actuelles */}
//                 {renderAnswerInput()}

//                 {/* ✅ Ajouter ici l'input + bouton pour ajouter une réponse */}
//                 {/* {selectedQuestion?.questionType !== "VRAI_FAUX" && (
//                   <>
//                     <Input
//                       placeholder="Nouvelle réponse"
//                       value={newAnswerText}
//                       onChange={(e) => setNewAnswerText(e.target.value)}
//                       style={{ marginTop: 10 }}
//                     />
//                     <Button
//                       type="primary"
//                       onClick={handleAddAnswer}
//                       icon={<PlusOutlined />}
//                       style={{ marginTop: 10 }}
//                     >
//                       Ajouter une réponse
//                     </Button>
//                   </>
//                 )} */}
//                 {selectedQuestion?.questionType !== "VRAI_FAUX" &&
//                   selectedQuestion?.questionType !== "MATCHING" &&
//                   selectedQuestion?.questionType !== "DRAG_DROP_ZONES" && (
//                     <>
//                       <Input
//                         placeholder="Nouvelle réponse"
//                         value={newAnswerText}
//                         onChange={(e) => setNewAnswerText(e.target.value)}
//                         style={{ marginTop: 10 }}
//                       />
//                       <Button
//                         type="primary"
//                         onClick={handleAddAnswer}
//                         icon={<PlusOutlined />}
//                         style={{ marginTop: 10 }}
//                       >
//                         Ajouter une réponse
//                       </Button>
//                     </>
//                   )}



//               </Card>

//             </>
//           )}
//         </div>
//       )}
//     </div>
//   );
//   const [form] = Form.useForm();

//   return (

//     <>

//       <>
//         {/* 🔵 Version intégrée dans la page */}
//         {showInPage && renderControleConnaissanceManagement()}

//         {/* 🔵 Ancienne version avec bouton + modal */}
//         {!showInPage && (
//           <>
//             <Button onClick={() => setIsModalVisible(true)}>Gérer les Quizzes</Button>
//             <Modal
//               title="Gestion des Quizzes"
//               visible={isModalVisible}
//               onCancel={() => setIsModalVisible(false)}
//               footer={<Button onClick={() => setIsModalVisible(false)}>Fermer</Button>}
//               width="95%"
//             >
//               {renderControleConnaissanceManagement()}
//             </Modal>
//           </>
//         )}
//       </>
//     </>

//   );
// };

// export default EvaluationsManager;

import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Card, List, Input, Checkbox, message, Spin, Progress, Select, Radio, Tag, Tabs, Col, Row, Form, Divider, Space, Typography, Badge } from "antd";
import { DeleteOutlined, PlusOutlined, EditOutlined, MinusOutlined, CloseOutlined, InfoCircleOutlined, CheckOutlined, CheckCircleTwoTone, CloseCircleTwoTone, LoadingOutlined, SaveOutlined, PlusCircleOutlined, QuestionCircleOutlined, FileTextOutlined, SettingOutlined, BookOutlined } from "@ant-design/icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Editor } from "@tinymce/tinymce-react";
import courseService from "../../services/course.service";
import MatchingQuestion from "./MatchingQuestion";
import DragDropMatching from "./quizes/DragDropMatching";
import DragDropZones from "./quizes/DragDropZones";
import DragDropImage from "./quizes/drag_drop_images/DragDropImage";

const { TextArea } = Input;
const { Title, Text } = Typography;
const { TabPane } = Tabs;

const EvaluationsManager = ({ subjectId, courseId, showInPage = false }) => {
  const editorRef = useRef(null);

  // Helpers message centrés
  const notifyError = (content, duration = 8) =>
    message.error({ content, duration, style: { marginTop: '20vh', textAlign: 'center' } });
  const notifySuccess = (content, duration = 4) =>
    message.success({ content, duration, style: { marginTop: '20vh', textAlign: 'center' } });

  const ensureNotExceed100 = async ({ courseId, type, newValue, oldValue = 0 }) => {
    const rows = await courseService.getTotalPourcentage(courseId);
    const norm = (t) => (t || "").toLowerCase();
    const isTotalRow = (t) => norm(t) === "total";
    const sumOthers = (rows || [])
      .filter((r) => !isTotalRow(r.type) && norm(r.type) !== norm(type))
      .reduce((s, r) => s + Number(r.totalPourcentage || 0), 0);
    const currentType = (rows || []).find((r) => norm(r.type) === norm(type));
    const currentTypeTotal = Number(currentType?.totalPourcentage || 0);
    const futureGlobal = sumOthers + (currentTypeTotal - Number(oldValue || 0) + Number(newValue || 0));
    if (futureGlobal > 100) {
      const dispo = Math.max(0, 100 - (sumOthers + currentTypeTotal - Number(oldValue || 0)));
      notifyError(`Le total global dépasserait 100 % (${futureGlobal.toFixed(2)} %). Il reste seulement ${dispo.toFixed(2)} % disponible.`);
      throw new Error("TOTAL_EXCEEDS_100");
    }
  };

  // --- TOUS LES STATES ---
  const [quizzes, setQuizzes] = useState([]);
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [answers, setAnswers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isQuizModalVisible, setIsQuizModalVisible] = useState(false);
  const [newQuizTitle, setNewQuizTitle] = useState("");
  const [newQuestionText, setNewQuestionText] = useState("");
  const [newQuestionType, setNewQuestionType] = useState("QCU");
  const [newAnswerText, setNewAnswerText] = useState("");
  const [newQuestionExplanation, setNewQuestionExplanation] = useState("");
  const [editQuizId, setEditQuizId] = useState(null);
  const [editQuizTitle, setEditQuizTitle] = useState("");
  const [attemptOnce, setAttemptOnce] = useState(false);
  const [editQuestionId, setEditQuestionId] = useState(null);
  const [editQuestionText, setEditQuestionText] = useState("");
  const [editQuestionScore, setEditQuestionScore] = useState("");
  const [editQuestionType, setEditQuestionType] = useState("");
  const [loadingSaveQuestion, setLoadingSaveQuestion] = useState(false);
  const [totalScore, setTotalScore] = useState(0);
  const [leftText, setLeftText] = useState("");
  const [rightText, setRightText] = useState("");
  const [selectedElementType, setSelectedElementType] = useState("SUBJECT");
  const [courseElements, setCourseElements] = useState([]);
  const [editElementType, setEditElementType] = useState("SUBJECT");
  const [editReferenceElementId, setEditReferenceElementId] = useState(null);
  const [editPositioning, setEditPositioning] = useState(null);
  const [editProgress, setEditProgress] = useState(0);
  const [originalProgress, setOriginalProgress] = useState(0);
  const [activeTab, setActiveTab] = useState("1");

  // Loading states
  const [loadingQuestions, setLoadingQuestions] = useState(false);
  const [loadingAnswers, setLoadingAnswers] = useState(false);
  const [loadingAddQuestion, setLoadingAddQuestion] = useState(false);
  const [loadingAddAnswer, setLoadingAddAnswer] = useState(false);
  const [loadingUpdateExplanation, setLoadingUpdateExplanation] = useState(false);
  const [loadingAddMatchingPair, setLoadingAddMatchingPair] = useState(false);
  const [loadingAddZone, setLoadingAddZone] = useState(false);
  const [loadingAddProposition, setLoadingAddProposition] = useState(false);
  const [loadingImageUpload, setLoadingImageUpload] = useState(false);
  const [loadingSelectCorrectAnswer, setLoadingSelectCorrectAnswer] = useState(false);

  // Feature states
  const [showMatchingAnswers, setShowMatchingAnswers] = useState(false);
  const [questionImageEnabled, setQuestionImageEnabled] = useState(false);

  // Drag Drop Image states
  const [isCreatingZone, setIsCreatingZone] = useState(false);
  const [tempZone, setTempZone] = useState(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [startPoint, setStartPoint] = useState(null);

  const [form] = Form.useForm();

  // ===================== FONCTIONS UTILITAIRES =====================

  const updateImageEverywhere = (imageUrl) => {
    setSelectedQuestion(prev => ({ ...prev, imageUrl }));
    setQuestions(prev => prev.map(q =>
      q.id === selectedQuestion.id ? { ...q, imageUrl } : q
    ));
  };

  const handleAddMatchingPair = async () => {
    if (!leftText.trim() || !rightText.trim() || !selectedQuestion) return;
    setLoadingAddMatchingPair(true);
    try {
      const pair = await courseService.addMatchingPairToQuestion(selectedQuestion.id, { leftText, rightText });
      setAnswers([...answers, pair]);
      setLeftText("");
      setRightText("");
      message.success("Paire ajoutée !");
    } catch (error) {
      message.error("Erreur lors de l'ajout de la paire.");
    } finally {
      setLoadingAddMatchingPair(false);
    }
  };

  const handleAddZone = async () => {
    if (!leftText.trim() || !rightText.trim() || !selectedQuestion) return;
    setLoadingAddZone(true);
    try {
      await courseService.addZoneToQuestion(selectedQuestion.id, { zoneLabel: leftText, correctAnswer: rightText });
      message.success("Zone ajoutée !");
      setLeftText("");
      setRightText("");
      const zones = await courseService.getZonesByQuestion(selectedQuestion.id);
      const propositions = await courseService.getPropositionsByQuestion(selectedQuestion.id);
      setAnswers([...zones.map(z => ({ ...z, isZone: true })), ...propositions.map(p => ({ ...p, isProposition: true }))]);
    } catch (error) {
      message.error("Erreur lors de l'ajout de la zone.");
    } finally {
      setLoadingAddZone(false);
    }
  };

  const handleAddProposition = async () => {
    if (!newAnswerText.trim() || !selectedQuestion) return;
    setLoadingAddProposition(true);
    try {
      await courseService.addPropositionToQuestion(selectedQuestion.id, { content: newAnswerText });
      message.success("Proposition ajoutée !");
      setNewAnswerText("");
      if (selectedQuestion.questionType === "DRAG_DROP_IMAGE") {
        const zones = await courseService.getImageZonesByQuestion(selectedQuestion.id);
        const propositions = await courseService.getPropositionsByQuestion(selectedQuestion.id);
        setAnswers([...zones.map(z => ({ ...z, isImageZone: true })), ...propositions.map(p => ({ ...p, isProposition: true }))]);
      } else {
        const zones = await courseService.getZonesByQuestion(selectedQuestion.id);
        const propositions = await courseService.getPropositionsByQuestion(selectedQuestion.id);
        setAnswers([...zones.map(z => ({ ...z, isZone: true })), ...propositions.map(p => ({ ...p, isProposition: true }))]);
      }
    } catch (error) {
      message.error("Erreur lors de l'ajout de la proposition.");
    } finally {
      setLoadingAddProposition(false);
    }
  };

  const handleAddImageZone = async () => {
    if (!leftText.trim() || !rightText.trim()) { message.warning("Veuillez remplir tous les champs"); return; }
    if (!tempZone) { message.warning("Veuillez dessiner une zone sur l'image"); return; }
    setLoadingAddZone(true);
    try {
      await courseService.addImageZoneToQuestion(selectedQuestion.id, {
        zoneLabel: leftText, correctAnswer: rightText,
        posX: tempZone.x, posY: tempZone.y,
        width: tempZone.width || 15, height: tempZone.height || 8
      });
      message.success("Zone ajoutée !");
      setLeftText(""); setRightText(""); setTempZone(null); setStartPoint(null);
      const zones = await courseService.getImageZonesByQuestion(selectedQuestion.id);
      const propositions = await courseService.getPropositionsByQuestion(selectedQuestion.id);
      setAnswers([...zones.map(z => ({ ...z, isImageZone: true })), ...propositions.map(p => ({ ...p, isProposition: true }))]);
    } catch (error) {
      message.error("Erreur lors de l'ajout de la zone.");
    } finally {
      setLoadingAddZone(false);
    }
  };

  const fetchElementsByType = async (type) => {
    if (type !== "SUBJECT") { setCourseElements([]); return; }
    try {
      const elements = await courseService.Getgroupnames(courseId);
      setCourseElements(Array.isArray(elements) ? elements : []);
    } catch (err) {
      message.error("Erreur chargement des groupes");
    }
  };

  const handleEditQuestion = async () => {
    if (!editQuestionText.trim() || !editQuestionId) return;
    setLoadingSaveQuestion(true);
    try {
      await courseService.updateQuestion(editQuestionId, { text: editQuestionText, score: editQuestionScore, questionType: editQuestionType });
      message.success("Question mise à jour !");
      setQuestions(questions.map(q => q.id === editQuestionId ? { ...q, text: editQuestionText, score: editQuestionScore, questionType: editQuestionType } : q));
      setEditQuestionId(null); setEditQuestionText(""); setEditQuestionScore(""); setEditQuestionType("");
    } catch (error) {
      message.error("Erreur lors de la mise à jour de la question.");
    }
    setLoadingSaveQuestion(false);
  };

  // ===================== USE EFFECTS =====================

  useEffect(() => {
    const fetchQuizzes = async () => {
      try {
        setLoading(true);
        let response = [];
        if (courseId) {
          response = await courseService.getEvaluationsSummary(courseId);
        } else if (subjectId) {
          response = await courseService.getQuizzesBySubject(subjectId);
        }
        setQuizzes(response);
      } catch (error) {
        message.error("Erreur lors de la récupération des évaluations.");
      } finally {
        setLoading(false);
      }
    };
    fetchQuizzes();
  }, [courseId, subjectId]);

  useEffect(() => {
    const total = questions.reduce((sum, q) => sum + (parseFloat(q.score) || 0), 0);
    setTotalScore(total);
  }, [questions]);

  // ===================== HANDLERS =====================

  const handleSelectQuiz = async (quiz) => {
    setSelectedQuiz(quiz);
    setActiveTab("1");
    setLoadingQuestions(true);
    try {
      const response = await courseService.getQuestionsByQuiz(quiz.id);
      setQuestions(response);
      setSelectedQuestion(null);
      setAnswers([]);
    } catch (error) {
      message.error("Erreur lors de la récupération des questions.");
    } finally {
      setLoadingQuestions(false);
    }
  };

  const handleEditQuizClick = (quiz) => {
    setEditQuizId(quiz.id);
    setEditQuizTitle(quiz.title);
    setAttemptOnce(quiz.attemptOnce || false);
    setEditElementType(quiz.elementType || "SUBJECT");
    setEditReferenceElementId(quiz.referenceElementId || null);
    setEditPositioning(quiz.positioning || null);
    const p = Number(quiz.progressPercentage || 0);
    setEditProgress(p);
    setOriginalProgress(p);
    if (quiz.elementType === "SUBJECT") fetchElementsByType("SUBJECT");
  };

  const handleDeleteQuiz = async (quizId) => {
    Modal.confirm({
      title: "Êtes-vous sûr de vouloir supprimer cette évaluation ?",
      content: "Cette action est irréversible.",
      okText: "Oui, supprimer", okType: "danger", cancelText: "Annuler",
      onOk: async () => {
        try {
          await courseService.deleteQuiz(quizId);
          message.success("Évaluation supprimée !");
          setQuizzes(quizzes.filter(q => q.id !== quizId));
        } catch (error) {
          message.error("Erreur lors de la suppression.");
        }
      },
    });
  };

  const handleAddQuestion = async () => {
    if (!newQuestionText.trim() || !selectedQuiz) return;
    setLoadingAddQuestion(true);
    try {
      const newQuestion = await courseService.addQuestionToQuiz(selectedQuiz.id, {
        text: newQuestionText, explanation: "", questionType: newQuestionType,
        quiz: { id: selectedQuiz.id }, score: 0
      });
      setQuestions([...questions, newQuestion]);
      setNewQuestionText("");
      message.success("Question ajoutée !");
      if (newQuestionType === "VRAI_FAUX") {
        const trueAnswer = await courseService.addAnswerToQuestion(newQuestion.id, { text: "Vrai", isCorrect: false });
        const falseAnswer = await courseService.addAnswerToQuestion(newQuestion.id, { text: "Faux", isCorrect: false });
        setAnswers([trueAnswer, falseAnswer]);
      }
    } catch (error) {
      message.error("Erreur lors de l'ajout de la question.");
    } finally {
      setLoadingAddQuestion(false);
    }
  };

  const handleDeleteQuestion = async (questionId) => {
    Modal.confirm({
      title: "Supprimer cette question ?", content: "Irréversible.",
      okText: "Supprimer", okType: "danger", cancelText: "Annuler",
      onOk: async () => {
        try {
          await courseService.deleteQuestion(questionId);
          message.success("Question supprimée !");
          setQuestions(questions.filter(q => q.id !== questionId));
          if (selectedQuestion?.id === questionId) { setSelectedQuestion(null); setAnswers([]); }
        } catch (error) { message.error("Erreur lors de la suppression."); }
      },
    });
  };

  const handleAddQuiz = async () => {
    try {
      await form.validateFields();
      const payload = { title: newQuizTitle, attemptOnce, referenceElementId: 0, positioning: 0 };
      const newQuiz = await courseService.addEvaluationToCourse(courseId, payload);
      message.success("Évaluation ajoutée !");
      setQuizzes([...quizzes, newQuiz]);
      setNewQuizTitle("");
      setIsQuizModalVisible(false);
      form.resetFields();
    } catch (error) {
      message.error("Erreur lors de l'ajout.");
    }
  };

  const handleSaveQuiz = async (quizId) => {
    if (!editQuizTitle.trim()) return;
    try {
      await ensureNotExceed100({ courseId, type: "evaluation", newValue: editProgress, oldValue: originalProgress });
      await courseService.updateQuiz(quizId, {
        title: editQuizTitle, attemptOnce, elementType: editElementType,
        referenceElementId: editReferenceElementId, positioning: editPositioning,
        progressPercentage: editProgress,
      });
      notifySuccess("Évaluation mise à jour !");
      setQuizzes(qs => qs.map(q => q.id === quizId ? { ...q, title: editQuizTitle, attemptOnce, progressPercentage: editProgress } : q));
      setEditQuizId(null); setEditQuizTitle("");
    } catch (err) {
      if (err?.message !== "TOTAL_EXCEEDS_100") notifyError("Erreur lors de la mise à jour.");
    }
  };

  const handleSelectQuestion = async (question) => {
    setSelectedQuestion(question);
    setNewQuestionExplanation(question.explanation || "");
    setQuestionImageEnabled(!!question.imageUrl);
    setActiveTab("3");
    setLoadingAnswers(true);
    try {
      if (question.questionType === "MATCHING") {
        const response = await courseService.getMatchingPairsByQuestion(question.id);
        setAnswers(response);
      } else if (question.questionType === "DRAG_DROP_ZONES") {
        const zones = await courseService.getZonesByQuestion(question.id);
        const propositions = await courseService.getPropositionsByQuestion(question.id);
        setAnswers([...zones.map(z => ({ ...z, isZone: true })), ...propositions.map(p => ({ ...p, isProposition: true }))]);
      } else if (question.questionType === "DRAG_DROP_IMAGE") {
        const zones = await courseService.getImageZonesByQuestion(question.id);
        const propositions = await courseService.getPropositionsByQuestion(question.id);
        setAnswers([...zones.map(z => ({ ...z, isImageZone: true })), ...propositions.map(p => ({ ...p, isProposition: true }))]);
      } else {
        const response = await courseService.getAnswersByQuestion(question.id);
        setAnswers(response);
      }
    } catch (error) {
      message.error("Erreur lors de la récupération des réponses.");
    } finally {
      setLoadingAnswers(false);
    }
  };

  const handleUpdateExplanation = async () => {
    if (!selectedQuestion) return;
    setLoadingUpdateExplanation(true);
    try {
      await courseService.updateQuestionExplanation(selectedQuestion.id, newQuestionExplanation);
      message.success("Explication mise à jour !");
    } catch (error) {
      message.error("Erreur lors de la mise à jour.");
    } finally {
      setLoadingUpdateExplanation(false);
    }
  };

  const handleAddAnswer = async () => {
    if (!newAnswerText.trim() || !selectedQuestion) return;
    setLoadingAddAnswer(true);
    try {
      const savedAnswer = await courseService.addAnswerToQuestion(selectedQuestion.id, { text: newAnswerText, isCorrect: false });
      setAnswers([...answers, savedAnswer]);
      setNewAnswerText("");
      message.success("Réponse ajoutée !");
    } catch (error) {
      message.error("Erreur lors de l'ajout.");
    } finally {
      setLoadingAddAnswer(false);
    }
  };

  const handleSelectCorrectAnswer = async (selectedId) => {
    if (!selectedQuestion) return;
    setLoadingSelectCorrectAnswer(true);
    let updatedAnswers;
    if (selectedQuestion.questionType === "QCU" || selectedQuestion.questionType === "VRAI_FAUX") {
      updatedAnswers = answers.map(a => ({ ...a, isCorrect: a.id === selectedId }));
    } else if (selectedQuestion.questionType === "QCM") {
      updatedAnswers = answers.map(a => a.id === selectedId ? { ...a, isCorrect: !a.isCorrect } : a);
    }
    setAnswers(updatedAnswers);
    try {
      const correctAnswerIds = updatedAnswers.filter(a => a.isCorrect).map(a => a.id);
      await courseService.updateCorrectAnswers(selectedQuestion.id, correctAnswerIds);
      message.success("Réponses mises à jour !");
    } catch (error) {
      message.error("Erreur lors de la mise à jour.");
    } finally {
      setLoadingSelectCorrectAnswer(false);
    }
  };

  const handleValidateDragDropOrder = async () => {
    if (!selectedQuestion) return;
    try {
      const orderedAnswerIds = answers.map(a => a.id);
      await courseService.updateAnswersOrder(selectedQuestion.id, orderedAnswerIds);
      message.success("Ordre sauvegardé !");
    } catch (error) {
      message.error("Erreur lors de la sauvegarde.");
    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = Array.from(answers);
    const [movedItem] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, movedItem);
    setAnswers(reordered);
  };

  // ===================== renderImageOption =====================
  const renderImageOption = () => {
    if (!selectedQuestion) return null;
    const isCompatibleType = ["QCU", "QCM", "VRAI_FAUX"].includes(selectedQuestion.questionType);
    if (!isCompatibleType) return null;

    return (
      <div style={{ marginTop: '12px' }}>
        <div style={{
          padding: '12px 16px',
          background: questionImageEnabled ? 'linear-gradient(135deg, #e6f7ff 0%, #f0f5ff 100%)' : '#fafafa',
          borderRadius: '8px', border: questionImageEnabled ? '1px solid #91d5ff' : '1px solid #e8e8e8',
          marginBottom: questionImageEnabled ? '12px' : '0', transition: 'all 0.3s ease'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Checkbox checked={questionImageEnabled} onChange={(e) => {
              setQuestionImageEnabled(e.target.checked);
              if (!e.target.checked && selectedQuestion.imageUrl) {
                Modal.confirm({
                  title: "Supprimer l'image ?", okText: "Supprimer", cancelText: "Annuler", okButtonProps: { danger: true },
                  onOk: async () => { try { await courseService.updateQuestionImage(selectedQuestion.id, ""); updateImageEverywhere(null); message.success("Image supprimée !"); } catch (e) { message.error("Erreur"); } },
                  onCancel: () => setQuestionImageEnabled(true)
                });
              }
            }}>
              <span style={{ fontSize: '13px', fontWeight: '600', color: questionImageEnabled ? '#1890ff' : '#666' }}>🖼️ Image illustrative</span>
            </Checkbox>
            {selectedQuestion.imageUrl && <Tag color="green" style={{ fontSize: '10px', margin: 0 }}>✓ Image active</Tag>}
          </div>
          {!questionImageEnabled && <Text style={{ fontSize: '11px', color: '#999', display: 'block', marginLeft: '24px', marginTop: '2px' }}>Activez pour ajouter une image à droite des réponses</Text>}
        </div>

        {questionImageEnabled && (
          <Spin spinning={loadingImageUpload} tip="Upload en cours...">
            <div style={{ background: 'white', borderRadius: '8px', border: '1px solid #e8e8e8', overflow: 'hidden' }}>
              <div style={{ padding: '10px 14px', background: 'linear-gradient(135deg, #fa8c16 0%, #ff7a45 100%)', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '16px' }}>📷</span>
                <Text strong style={{ fontSize: '12px', color: 'white' }}>Image de la question</Text>
              </div>
              <div style={{ padding: '14px' }}>
                {selectedQuestion.imageUrl && (
                  <div style={{ marginBottom: '12px', borderRadius: '8px', overflow: 'hidden', border: '2px solid #f0f0f0', position: 'relative', background: '#fafafa' }}>
                    <img src={selectedQuestion.imageUrl} alt="Preview" style={{ width: '100%', display: 'block', objectFit: 'contain', maxHeight: '180px' }} onError={(e) => { e.target.style.display = 'none'; }} />
                    <Button type="primary" danger size="small" icon={<DeleteOutlined />} onClick={() => {
                      Modal.confirm({ title: "Supprimer l'image ?", okText: "Supprimer", cancelText: "Annuler", okButtonProps: { danger: true },
                        onOk: async () => { try { await courseService.updateQuestionImage(selectedQuestion.id, ""); updateImageEverywhere(null); message.success("Image supprimée !"); } catch (e) { message.error("Erreur"); } }
                      });
                    }} style={{ position: 'absolute', top: '8px', right: '8px', borderRadius: '6px', fontSize: '11px', height: '28px', boxShadow: '0 2px 6px rgba(0,0,0,0.2)' }}>Supprimer</Button>
                  </div>
                )}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                  <div style={{ padding: '10px', background: '#f8f9fa', borderRadius: '6px', border: '1px dashed #d9d9d9' }}>
                    <Text strong style={{ fontSize: '11px', color: '#666', display: 'block', marginBottom: '6px' }}>📁 Depuis un fichier</Text>
                    <Input type="file" accept="image/*" onChange={async (e) => {
                      const file = e.target.files[0]; if (!file) return;
                      setLoadingImageUpload(true);
                      const reader = new FileReader();
                      reader.onload = async (event) => { const b64 = event.target.result; try { await courseService.updateQuestionImage(selectedQuestion.id, b64); updateImageEverywhere(b64); message.success("Image ajoutée !"); } catch (er) { message.error("Erreur"); } finally { setLoadingImageUpload(false); } };
                      reader.readAsDataURL(file);
                    }} size="small" style={{ fontSize: '11px' }} />
                  </div>
                  <div style={{ padding: '10px', background: '#f8f9fa', borderRadius: '6px', border: '1px dashed #d9d9d9' }}>
                    <Text strong style={{ fontSize: '11px', color: '#666', display: 'block', marginBottom: '6px' }}>🔗 Depuis une URL</Text>
                    <Input placeholder="https://exemple.com/image.png" value={selectedQuestion.imageUrl && !selectedQuestion.imageUrl.startsWith('data:') ? selectedQuestion.imageUrl : ""} onChange={(e) => setSelectedQuestion({ ...selectedQuestion, imageUrl: e.target.value })}
                      onBlur={async () => { if (selectedQuestion.imageUrl && !selectedQuestion.imageUrl.startsWith('data:')) { setLoadingImageUpload(true); try { await courseService.updateQuestionImage(selectedQuestion.id, selectedQuestion.imageUrl); updateImageEverywhere(selectedQuestion.imageUrl); message.success("URL sauvegardée !"); } catch (e) { message.error("Erreur"); } finally { setLoadingImageUpload(false); } } }}
                      onPressEnter={async () => { if (selectedQuestion.imageUrl && !selectedQuestion.imageUrl.startsWith('data:')) { setLoadingImageUpload(true); try { await courseService.updateQuestionImage(selectedQuestion.id, selectedQuestion.imageUrl); updateImageEverywhere(selectedQuestion.imageUrl); message.success("URL sauvegardée !"); } catch (e) { message.error("Erreur"); } finally { setLoadingImageUpload(false); } } }}
                      size="small" style={{ fontSize: '11px' }} />
                  </div>
                </div>
                <div style={{ marginTop: '10px', padding: '6px 10px', background: '#f6ffed', borderRadius: '4px', border: '1px solid #b7eb8f', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <InfoCircleOutlined style={{ color: '#52c41a', fontSize: '12px' }} />
                  <Text style={{ fontSize: '10px', color: '#389e0d' }}>L'image apparaîtra à droite des réponses côté apprenant.</Text>
                </div>
              </div>
            </div>
          </Spin>
        )}
      </div>
    );
  };

  // ===================== renderAnswerInput =====================
  const renderAnswerInput = () => {
    if (!selectedQuestion) return null;

    switch (selectedQuestion.questionType) {
      case "QCU":
        return (
          <div style={{ padding: '10px', background: '#f8f9fa', borderRadius: '6px' }}>
            <div style={{ display: selectedQuestion.imageUrl ? 'grid' : 'block', gridTemplateColumns: selectedQuestion.imageUrl ? '1fr 1fr' : '1fr', gap: '16px' }}>
              <div>
                <Title level={5} style={{ marginBottom: '10px', color: '#1890ff', fontSize: '13px' }}><QuestionCircleOutlined /> Sélectionnez la bonne réponse</Title>
                <Radio.Group value={answers.find(a => a.isCorrect)?.id} onChange={(e) => handleSelectCorrectAnswer(e.target.value)} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  {answers.map(answer => (
                    <Radio key={answer.id} value={answer.id} style={{ padding: '6px 10px', background: 'white', borderRadius: '4px', border: '1px solid #d9d9d9', fontSize: '13px' }}>{answer.text}</Radio>
                  ))}
                </Radio.Group>
              </div>
              {selectedQuestion.imageUrl && (
                <div style={{ border: '2px solid #e8e8e8', borderRadius: '8px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa', position: 'relative' }}>
                  <div style={{ position: 'absolute', top: '8px', left: '8px', background: 'rgba(0,0,0,0.5)', color: 'white', padding: '2px 8px', borderRadius: '4px', fontSize: '10px', zIndex: 1 }}>🖼️ Image</div>
                  <img src={selectedQuestion.imageUrl} alt="Question" style={{ width: '100%', display: 'block', objectFit: 'contain', maxHeight: '350px' }} />
                </div>
              )}
            </div>
          </div>
        );

      case "QCM":
        return (
          <div style={{ padding: '10px', background: '#f8f9fa', borderRadius: '6px' }}>
            <div style={{ display: selectedQuestion.imageUrl ? 'grid' : 'block', gridTemplateColumns: selectedQuestion.imageUrl ? '1fr 1fr' : '1fr', gap: '16px' }}>
              <div>
                <Title level={5} style={{ marginBottom: '10px', color: '#1890ff', fontSize: '13px' }}><CheckOutlined /> Sélectionnez les bonnes réponses</Title>
                <Checkbox.Group value={answers.filter(a => a.isCorrect).map(a => a.id)} onChange={(checkedValues) => {
                  const updatedAnswers = answers.map(a => ({ ...a, isCorrect: checkedValues.includes(a.id) }));
                  setAnswers(updatedAnswers);
                  courseService.updateCorrectAnswers(selectedQuestion.id, updatedAnswers.filter(a => a.isCorrect).map(a => a.id))
                    .then(() => message.success("Réponses mises à jour !"))
                    .catch(() => message.error("Erreur"));
                }} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  {answers.map(answer => (
                    <Checkbox key={answer.id} value={answer.id} style={{ padding: '6px 10px', background: 'white', borderRadius: '4px', border: '1px solid #d9d9d9', fontSize: '13px' }}>{answer.text}</Checkbox>
                  ))}
                </Checkbox.Group>
              </div>
              {selectedQuestion.imageUrl && (
                <div style={{ border: '2px solid #e8e8e8', borderRadius: '8px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa', position: 'relative' }}>
                  <div style={{ position: 'absolute', top: '8px', left: '8px', background: 'rgba(0,0,0,0.5)', color: 'white', padding: '2px 8px', borderRadius: '4px', fontSize: '10px', zIndex: 1 }}>🖼️ Image</div>
                  <img src={selectedQuestion.imageUrl} alt="Question" style={{ width: '100%', display: 'block', objectFit: 'contain', maxHeight: '350px' }} />
                </div>
              )}
            </div>
          </div>
        );

      case "VRAI_FAUX":
        return (
          <div style={{ padding: '10px', background: '#f8f9fa', borderRadius: '6px' }}>
            <div style={{ display: selectedQuestion.imageUrl ? 'grid' : 'block', gridTemplateColumns: selectedQuestion.imageUrl ? '1fr 1fr' : '1fr', gap: '16px' }}>
              <div>
                <Title level={5} style={{ marginBottom: '10px', color: '#1890ff', fontSize: '13px' }}><QuestionCircleOutlined /> Vrai ou Faux ?</Title>
                <Radio.Group value={answers.find(a => a.isCorrect)?.id} onChange={(e) => handleSelectCorrectAnswer(e.target.value)} style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                  {answers.map(answer => (
                    <Radio key={answer.id} value={answer.id} style={{ padding: '10px 16px', background: 'white', borderRadius: '4px', border: '2px solid #d9d9d9', fontSize: '13px', fontWeight: '500' }}>
                      {answer.text === "Vrai" ? "✓ Vrai" : "✗ Faux"}
                    </Radio>
                  ))}
                </Radio.Group>
              </div>
              {selectedQuestion.imageUrl && (
                <div style={{ border: '2px solid #e8e8e8', borderRadius: '8px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa', position: 'relative' }}>
                  <div style={{ position: 'absolute', top: '8px', left: '8px', background: 'rgba(0,0,0,0.5)', color: 'white', padding: '2px 8px', borderRadius: '4px', fontSize: '10px', zIndex: 1 }}>🖼️ Image</div>
                  <img src={selectedQuestion.imageUrl} alt="Question" style={{ width: '100%', display: 'block', objectFit: 'contain', maxHeight: '350px' }} />
                </div>
              )}
            </div>
          </div>
        );

      case "DRAG_DROP":
        return (
          <div style={{ padding: '10px', background: '#f8f9fa', borderRadius: '6px' }}>
            <Title level={5} style={{ marginBottom: '10px', color: '#1890ff', fontSize: '13px' }}>Glissez-déposez pour ordonner</Title>
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="answers-list">
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {answers.map((answer, index) => (
                      <Draggable key={String(answer.id)} draggableId={String(answer.id)} index={index}>
                        {(provided, snapshot) => (
                          <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={{ padding: "8px", margin: "4px 0", background: snapshot.isDragging ? "#e6f7ff" : "#ffffff", border: "1px solid #d9d9d9", borderRadius: "4px", fontSize: "13px", cursor: "grab", ...provided.draggableProps.style }}>
                            <Badge count={index + 1} style={{ marginRight: '6px', fontSize: '10px' }} />{answer.text}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
            <Button type="primary" icon={<SaveOutlined />} style={{ marginTop: "8px" }} onClick={handleValidateDragDropOrder} size="small">Sauvegarder</Button>
          </div>
        );

      case "MATCHING":
        return (
          <div style={{ padding: '10px', background: '#f8f9fa', borderRadius: '6px' }}>
            <Title level={5} style={{ marginBottom: '10px', color: '#1890ff', fontSize: '13px' }}>Appariement - Mode interactif</Title>
            {answers.length > 0 ? (
              <>
                <DragDropMatching questionText="Glissez les éléments de droite vers ceux de gauche" matchingPairs={answers.map(a => ({ id: a.id, leftItem: a.leftText || "Gauche", rightItem: a.rightText || "Droite" }))} onAnswerChange={(u) => console.log('Réponses:', u)} showCorrectAnswers={showMatchingAnswers} isReadOnly={false} />
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                  <Button type={showMatchingAnswers ? "default" : "primary"} icon={showMatchingAnswers ? <CloseOutlined /> : <CheckOutlined />} onClick={() => setShowMatchingAnswers(!showMatchingAnswers)} size="small" style={{ height: '32px', borderRadius: '6px', fontSize: '13px', fontWeight: '600' }}>
                    {showMatchingAnswers ? "❌ Masquer" : "✅ Vérifier"}
                  </Button>
                </div>
              </>
            ) : (
              <div style={{ padding: '20px', textAlign: 'center', color: '#999', background: 'white', borderRadius: '6px', border: '1px dashed #d9d9d9' }}>
                <InfoCircleOutlined style={{ fontSize: '24px', marginBottom: '8px' }} />
                <Text style={{ display: 'block', fontSize: '13px' }}>Aucune paire. Ajoutez-en ci-dessous.</Text>
              </div>
            )}
            <Divider style={{ margin: '15px 0' }} />
            <Title level={5} style={{ fontSize: '13px' }}>Ajouter une paire</Title>
            <Row gutter={10} style={{ marginTop: '8px' }}>
              <Col span={10}><Input placeholder="Texte gauche" value={leftText} onChange={(e) => setLeftText(e.target.value)} size="small" /></Col>
              <Col span={10}><Input placeholder="Texte droit" value={rightText} onChange={(e) => setRightText(e.target.value)} size="small" /></Col>
              <Col span={4}><Button type="primary" icon={<PlusOutlined />} onClick={handleAddMatchingPair} loading={loadingAddMatchingPair} size="small" style={{ width: '100%' }}>+</Button></Col>
            </Row>
          </div>
        );

      case "DRAG_DROP_ZONES":
        return (
          <div style={{ padding: '16px', background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', borderRadius: '8px', border: '1px solid #dee2e6' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px', padding: '12px', background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)', borderRadius: '8px' }}>
              <div style={{ background: 'white', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px' }}>🎯</div>
              <div><Title level={5} style={{ margin: 0, color: 'white', fontSize: '14px' }}>Zones à remplir</Title></div>
            </div>
            <Tabs defaultActiveKey="1" size="small">
              <TabPane tab="⚙️ Gestion" key="1">
                <div style={{ padding: '12px 0' }}>
                  {/* Propositions */}
                  <div style={{ background: 'white', borderRadius: '8px', padding: '16px', marginBottom: '16px', border: '1px solid #e8e8e8' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}><Title level={5} style={{ margin: 0, fontSize: '13px', color: '#52c41a' }}>🎲 Propositions</Title><Badge count={answers.filter(a => a.propositionContent).length} style={{ backgroundColor: '#52c41a' }} /></div>
                    {answers.filter(a => a.propositionContent).length > 0 && (
                      <div style={{ marginBottom: '12px', display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                        {answers.filter(a => a.propositionContent).map(prop => (<Tag key={prop.id} color="green">💡 {prop.propositionContent}</Tag>))}
                      </div>
                    )}
                    <Row gutter={10}>
                      <Col span={16}><Input prefix="💡" placeholder="Nouvelle proposition..." value={newAnswerText} onChange={(e) => setNewAnswerText(e.target.value)} /></Col>
                      <Col span={8}><Button type="primary" icon={<PlusOutlined />} onClick={handleAddProposition} loading={loadingAddProposition} style={{ width: '100%', background: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)', border: 'none' }}>Ajouter</Button></Col>
                    </Row>
                  </div>
                  {/* Zones */}
                  <div style={{ background: 'white', borderRadius: '8px', padding: '16px', border: '1px solid #e8e8e8', opacity: answers.filter(a => a.propositionContent).length === 0 ? 0.6 : 1, pointerEvents: answers.filter(a => a.propositionContent).length === 0 ? 'none' : 'auto' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}><Title level={5} style={{ margin: 0, fontSize: '13px', color: '#1976d2' }}>📍 Zones</Title><Badge count={answers.filter(a => a.zoneLabel).length} style={{ backgroundColor: '#1976d2' }} /></div>
                    {answers.filter(a => a.zoneLabel).length > 0 && (
                      <div style={{ marginBottom: '12px' }}>
                        {answers.filter(a => a.zoneLabel).map(zone => (
                          <div key={zone.id} style={{ display: 'flex', gap: '8px', padding: '6px', background: '#f8f9fa', borderRadius: '4px', marginBottom: '4px' }}>
                            <Tag color="blue">📍 {zone.zoneLabel}</Tag><span>→</span><Tag color="green">✓ {zone.correctAnswer}</Tag>
                          </div>
                        ))}
                      </div>
                    )}
                    <Row gutter={10}>
                      <Col span={8}><Input prefix="🏷️" placeholder="Label zone" value={leftText} onChange={(e) => setLeftText(e.target.value)} /></Col>
                      <Col span={12}><Select placeholder="Bonne réponse" value={rightText} onChange={(v) => setRightText(v)} style={{ width: '100%' }}>{answers.filter(a => a.propositionContent).map(p => (<Select.Option key={p.id} value={p.propositionContent}>💡 {p.propositionContent}</Select.Option>))}</Select></Col>
                      <Col span={4}><Button type="primary" icon={<PlusOutlined />} loading={loadingAddZone} onClick={handleAddZone} style={{ width: '100%', background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)', border: 'none' }}>Créer</Button></Col>
                    </Row>
                  </div>
                </div>
              </TabPane>
              <TabPane tab="🎮 Test" key="2">
                {answers.length > 0 ? (
                  <div style={{ background: 'white', borderRadius: '8px', padding: '16px' }}>
                    <DragDropZones zones={answers.filter(a => a.zoneLabel).map(a => ({ id: a.id, label: a.zoneLabel, correctAnswer: a.correctAnswer }))} propositions={answers.filter(a => a.propositionContent).map(a => ({ id: a.id, content: a.propositionContent }))} onAnswerChange={(a) => console.log('Zone:', a)} showCorrectAnswers={showMatchingAnswers} />
                    <div style={{ textAlign: 'center', marginTop: '16px' }}>
                      <Button type={showMatchingAnswers ? "default" : "primary"} icon={showMatchingAnswers ? <CloseOutlined /> : <CheckOutlined />} onClick={() => setShowMatchingAnswers(!showMatchingAnswers)}>{showMatchingAnswers ? "❌ Masquer" : "✅ Vérifier"}</Button>
                    </div>
                  </div>
                ) : <div style={{ padding: '48px', textAlign: 'center' }}><Text style={{ color: '#999' }}>Aucune zone configurée</Text></div>}
              </TabPane>
            </Tabs>
          </div>
        );

      case "DRAG_DROP_IMAGE":
        return (
          <div style={{ padding: '16px', background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', borderRadius: '8px', border: '1px solid #dee2e6' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px', padding: '12px', background: 'linear-gradient(135deg, #fa8c16 0%, #fa541c 100%)', borderRadius: '8px' }}>
              <div style={{ background: 'white', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px' }}>🖼️</div>
              <div><Title level={5} style={{ margin: 0, color: 'white', fontSize: '14px' }}>Drag & Drop sur Image</Title></div>
            </div>
            <Tabs defaultActiveKey="1" size="small">
              <TabPane tab="⚙️ Gestion" key="1">
                <div style={{ display: 'flex', gap: '20px', padding: '16px', background: 'white', borderRadius: '8px' }}>
                  <div style={{ flex: 1, border: '2px solid #e8e8e8', borderRadius: '8px', overflow: 'hidden' }}>
                    {selectedQuestion.imageUrl ? (
                      <div style={{ position: 'relative', border: isCreatingZone ? '3px dashed #1890ff' : 'none', cursor: isCreatingZone ? 'crosshair' : 'default' }}
                        onMouseDown={(e) => { if (!isCreatingZone) return; const rect = e.currentTarget.getBoundingClientRect(); setStartPoint({ x: ((e.clientX - rect.left) / rect.width) * 100, y: ((e.clientY - rect.top) / rect.height) * 100 }); setIsDrawing(true); }}
                        onMouseMove={(e) => { if (!isDrawing || !startPoint) return; const rect = e.currentTarget.getBoundingClientRect(); const cx = ((e.clientX - rect.left) / rect.width) * 100; const cy = ((e.clientY - rect.top) / rect.height) * 100; setTempZone({ x: Math.min(startPoint.x, cx), y: Math.min(startPoint.y, cy), width: Math.abs(cx - startPoint.x), height: Math.abs(cy - startPoint.y) }); }}
                        onMouseUp={() => { if (!isDrawing || !tempZone) return; setIsDrawing(false); setIsCreatingZone(false); message.info("Zone créée ! Définissez le label et la bonne réponse."); }}>
                        <img src={selectedQuestion.imageUrl} alt="Image" style={{ width: '100%', display: 'block', userSelect: 'none' }} draggable={false} />
                        {answers.filter(a => a.isImageZone).map(zone => (
                          <div key={zone.id} style={{ position: 'absolute', left: `${zone.posX}%`, top: `${zone.posY}%`, width: `${zone.width}%`, height: `${zone.height}%`, border: '2px solid #52c41a', backgroundColor: 'rgba(82, 196, 26, 0.2)', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: '600', color: '#52c41a', pointerEvents: 'none' }}>{zone.zoneLabel}</div>
                        ))}
                        {tempZone && <div style={{ position: 'absolute', left: `${tempZone.x}%`, top: `${tempZone.y}%`, width: `${tempZone.width || 15}%`, height: `${tempZone.height || 8}%`, border: '2px dashed #fa8c16', backgroundColor: 'rgba(250, 140, 22, 0.2)', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', color: '#fa8c16', pointerEvents: 'none' }}>{isDrawing ? "..." : "Nouvelle zone"}</div>}
                      </div>
                    ) : (
                      <div style={{ padding: '60px', textAlign: 'center', background: '#f8f9fa', minHeight: '400px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ fontSize: '64px', opacity: 0.3 }}>🖼️</div><Text style={{ color: '#999' }}>Uploadez une image</Text>
                      </div>
                    )}
                  </div>
                  {/* Panneau droit */}
                  <div style={{ width: '350px', background: '#f8f9fa', padding: '16px', borderRadius: '8px', border: '1px solid #e8e8e8', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <div style={{ background: 'white', borderRadius: '8px', padding: '12px', border: '1px solid #e8e8e8' }}>
                      <Title level={5} style={{ fontSize: '13px', color: '#fa8c16', marginBottom: '8px' }}>📷 Image de fond</Title>
                      <Input type="file" accept="image/*" onChange={async (e) => { const file = e.target.files[0]; if (!file) return; const reader = new FileReader(); reader.onload = async (ev) => { const b64 = ev.target.result; try { await courseService.updateQuestionImage(selectedQuestion.id, b64); setSelectedQuestion({ ...selectedQuestion, imageUrl: b64 }); setQuestions(prev => prev.map(q => q.id === selectedQuestion.id ? { ...q, imageUrl: b64 } : q)); message.success("Image ajoutée !"); } catch (er) { message.error("Erreur"); } }; reader.readAsDataURL(file); }} size="small" style={{ marginBottom: '8px' }} />
                      <Text style={{ fontSize: '11px', color: '#999' }}>ou URL :</Text>
                      <Input placeholder="URL" value={selectedQuestion.imageUrl || ""} onChange={async (e) => { const url = e.target.value; try { await courseService.updateQuestionImage(selectedQuestion.id, url); setSelectedQuestion({ ...selectedQuestion, imageUrl: url }); setQuestions(prev => prev.map(q => q.id === selectedQuestion.id ? { ...q, imageUrl: url } : q)); } catch (er) {} }} size="small" />
                    </div>
                    <Button type={isCreatingZone ? "primary" : "default"} icon={<PlusOutlined />} onClick={() => setIsCreatingZone(!isCreatingZone)} block style={{ height: '36px', fontWeight: '600' }}>{isCreatingZone ? "👆 Cliquez sur l'image" : "📍 Créer une zone"}</Button>
                    {isCreatingZone && <div style={{ padding: '8px', background: '#e6f7ff', borderRadius: '6px', fontSize: '11px', color: '#1890ff', textAlign: 'center' }}>Dessinez un rectangle sur l'image</div>}
                    {/* Propositions */}
                    <div style={{ background: 'white', borderRadius: '8px', padding: '12px', border: '1px solid #e8e8e8' }}>
                      <Title level={5} style={{ fontSize: '13px', color: '#52c41a', display: 'flex', alignItems: 'center', gap: '6px' }}>🎲 Propositions <Badge count={answers.filter(a => a.propositionContent).length} style={{ backgroundColor: '#52c41a' }} /></Title>
                      <div style={{ marginBottom: '8px', maxHeight: '120px', overflowY: 'auto' }}>
                        {answers.filter(a => a.propositionContent).map(prop => (
                          <div key={prop.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 8px', background: '#f8f9fa', borderRadius: '4px', marginBottom: '4px' }}>
                            <Tag color="green" style={{ margin: 0 }}>💡 {prop.propositionContent}</Tag>
                            <Button type="text" danger size="small" icon={<DeleteOutlined />} onClick={async () => { await courseService.deleteProposition(prop.id); const z = await courseService.getImageZonesByQuestion(selectedQuestion.id); const p = await courseService.getPropositionsByQuestion(selectedQuestion.id); setAnswers([...z.map(zz => ({ ...zz, isImageZone: true })), ...p.map(pp => ({ ...pp, isProposition: true }))]); message.success("Supprimée !"); }} />
                          </div>
                        ))}
                      </div>
                      <div style={{ display: 'flex', gap: '6px' }}>
                        <Input placeholder="Nouvelle proposition" value={newAnswerText} onChange={(e) => setNewAnswerText(e.target.value)} onPressEnter={handleAddProposition} size="small" />
                        <Button type="primary" icon={<PlusOutlined />} onClick={handleAddProposition} loading={loadingAddProposition} size="small">+</Button>
                      </div>
                    </div>
                    {/* Zones */}
                    <div style={{ background: 'white', borderRadius: '8px', padding: '12px', border: '1px solid #e8e8e8' }}>
                      <Title level={5} style={{ fontSize: '13px', color: '#1976d2', display: 'flex', alignItems: 'center', gap: '6px' }}>📍 Zones <Badge count={answers.filter(a => a.isImageZone).length} style={{ backgroundColor: '#1976d2' }} /></Title>
                      <div style={{ marginBottom: '8px', maxHeight: '100px', overflowY: 'auto' }}>
                        {answers.filter(a => a.isImageZone).map(zone => (
                          <div key={zone.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 8px', background: '#f8f9fa', borderRadius: '4px', marginBottom: '4px' }}>
                            <div style={{ display: 'flex', gap: '4px', alignItems: 'center', fontSize: '10px' }}><Tag color="blue" style={{ margin: 0 }}>{zone.zoneLabel}</Tag>→<Tag color="green" style={{ margin: 0 }}>{zone.correctAnswer}</Tag></div>
                            <Button type="text" danger size="small" icon={<DeleteOutlined />} onClick={async () => { await courseService.deleteImageZone(zone.id); const z = await courseService.getImageZonesByQuestion(selectedQuestion.id); const p = await courseService.getPropositionsByQuestion(selectedQuestion.id); setAnswers([...z.map(zz => ({ ...zz, isImageZone: true })), ...p.map(pp => ({ ...pp, isProposition: true }))]); message.success("Supprimée !"); }} />
                          </div>
                        ))}
                      </div>
                      <Input placeholder="Label" value={leftText} onChange={(e) => setLeftText(e.target.value)} size="small" prefix="🏷️" style={{ marginBottom: '6px' }} />
                      <Select placeholder="Bonne réponse" value={rightText} onChange={(v) => setRightText(v)} size="small" style={{ width: '100%', marginBottom: '6px' }}>
                        {answers.filter(a => a.propositionContent).map(p => (<Select.Option key={p.id} value={p.propositionContent}>💡 {p.propositionContent}</Select.Option>))}
                      </Select>
                      <Button type="primary" icon={<PlusOutlined />} onClick={handleAddImageZone} disabled={!tempZone} block size="small" loading={loadingAddZone}>Créer la zone</Button>
                      {tempZone && <div style={{ marginTop: '8px', padding: '6px', background: '#fff7e6', borderRadius: '4px', fontSize: '10px', color: '#fa8c16', textAlign: 'center' }}>⚠️ Zone temporaire prête</div>}
                    </div>
                  </div>
                </div>
              </TabPane>
              <TabPane tab="🎮 Test" key="2">
                {selectedQuestion.imageUrl && answers.filter(a => a.isImageZone).length > 0 ? (
                  <>
                    <DragDropImage imageUrl={selectedQuestion.imageUrl} dropZones={answers.filter(a => a.isImageZone).map(z => ({ id: z.id, label: z.zoneLabel, correctAnswer: z.correctAnswer, x: z.posX, y: z.posY, width: z.width, height: z.height }))} propositions={answers.filter(a => a.propositionContent).map(p => ({ id: p.id, content: p.propositionContent }))} onAnswerChange={(a) => console.log('Réponse:', a)} showCorrectAnswers={showMatchingAnswers} />
                    <div style={{ textAlign: 'center', marginTop: '16px' }}>
                      <Button type={showMatchingAnswers ? "default" : "primary"} onClick={() => setShowMatchingAnswers(!showMatchingAnswers)} icon={showMatchingAnswers ? <CloseOutlined /> : <CheckOutlined />} size="large">{showMatchingAnswers ? "❌ Masquer" : "✅ Vérifier"}</Button>
                    </div>
                  </>
                ) : <div style={{ padding: '60px', textAlign: 'center' }}><div style={{ fontSize: '64px', opacity: 0.5 }}>🎯</div><Text style={{ color: '#999' }}>Créez d'abord image + zones</Text></div>}
              </TabPane>
            </Tabs>
          </div>
        );

      default:
        return <div style={{ padding: '25px', textAlign: 'center', color: '#999' }}><InfoCircleOutlined style={{ fontSize: '32px', marginBottom: '10px' }} /><Text style={{ fontSize: '13px' }}>Aucune réponse disponible pour ce type.</Text></div>;
    }
  };

  // ===================== RENDU PRINCIPAL (MÊME LAYOUT QUE ControleConnaissanceManager) =====================
  const renderEvaluationManagement = () => (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f0f2f5 0%, #e6f7ff 100%)', padding: '12px' }}>
      {/* HEADER */}
      <div style={{ background: 'white', borderRadius: '6px', padding: '12px 16px', marginBottom: '12px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)', border: '1px solid #e8e8e8' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <Title level={3} style={{ margin: 0, color: '#1890ff', fontSize: '18px' }}><BookOutlined style={{ marginRight: '6px' }} /></Title>
            <Text type="secondary" style={{ fontSize: '13px' }}>Créez et gérez vos évaluations</Text>
          </div>
          <Badge count={quizzes.length} style={{ backgroundColor: '#52c41a' }}>
            <Button type="primary" size="small" icon={<PlusCircleOutlined />} onClick={() => setIsQuizModalVisible(true)} disabled={quizzes.length >= 1} style={{ height: '32px', borderRadius: '6px', fontSize: '13px', fontWeight: '600' }}>
              Nouvelle Évaluation
            </Button>
          </Badge>
        </div>
      </div>

      {/* GRILLE 1fr 2fr */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: "12px" }}>
        {/* SECTION GAUCHE : LISTE DES ÉVALUATIONS */}
        <Card
          title={<div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><FileTextOutlined style={{ color: '#1890ff', fontSize: '13px' }} /><span style={{ fontSize: '13px' }}>Liste des Évaluations</span><Badge count={quizzes.length} style={{ backgroundColor: '#f5f5f5', color: '#666', fontSize: '11px' }} /></div>}
          style={{ height: 'fit-content', borderRadius: '6px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)' }}
          bodyStyle={{ padding: '10px' }}
        >
          {loading ? (
            <div style={{ textAlign: 'center', padding: '20px' }}><Spin /><Text style={{ display: 'block', marginTop: '8px', fontSize: '12px' }}>Chargement...</Text></div>
          ) : (
            <List
              dataSource={quizzes}
              renderItem={(quiz) => (
                <List.Item style={{ border: 'none', padding: '0' }}>
                  {editQuizId === quiz.id ? (
                    <Card style={{ width: '100%', border: "2px solid #1890ff", borderRadius: "6px", backgroundColor: "#f0f8ff", marginBottom: '10px' }} bodyStyle={{ padding: '10px' }}>
                      <Title level={5} style={{ color: "#1890ff", marginBottom: '10px', fontSize: '13px' }}><EditOutlined /> Modification</Title>
                      <Space direction="vertical" style={{ width: '100%' }} size="small">
                        <div><Text strong style={{ fontSize: '12px' }}>Titre</Text><Input value={editQuizTitle} onChange={(e) => setEditQuizTitle(e.target.value)} size="small" style={{ marginTop: '4px' }} /></div>
                        <Checkbox checked={attemptOnce} onChange={(e) => setAttemptOnce(e.target.checked)}><Text strong style={{ fontSize: '12px' }}>Tentative unique</Text></Checkbox>
                        <div>
                          <Text strong style={{ fontSize: '12px' }}>Progression (%)</Text>
                          <div style={{ display: "flex", alignItems: "center", gap: '6px', marginTop: '4px' }}>
                            <Button icon={<MinusOutlined />} onClick={() => setEditProgress(v => Math.max(0, (v || 0) - 5))} size="small" />
                            <Progress type="circle" percent={editProgress || 0} width={40} strokeColor="#1890ff" />
                            <Button icon={<PlusOutlined />} onClick={() => setEditProgress(v => Math.min(100, (v || 0) + 5))} size="small" />
                          </div>
                          <Input type="number" value={editProgress} onChange={(e) => setEditProgress(Math.max(0, Math.min(100, Number(e.target.value) || 0)))} min={0} max={100} style={{ marginTop: '6px' }} suffix="%" size="small" />
                        </div>
                        <div><Text strong style={{ fontSize: '12px' }}>Type d'élément</Text><Select value={editElementType} onChange={(val) => { setEditElementType(val); setEditReferenceElementId(null); if (val === "SUBJECT") fetchElementsByType(val); }} style={{ width: '100%', marginTop: '4px' }} size="small"><Select.Option value="SUBJECT">Sujet</Select.Option><Select.Option value="TRAINING">Entraînement</Select.Option></Select></div>
                        <div><Text strong style={{ fontSize: '12px' }}>Élément de référence</Text><Select value={editReferenceElementId} onChange={(val) => setEditReferenceElementId(val)} disabled={editElementType !== "SUBJECT"} placeholder="Choisir" style={{ width: '100%', marginTop: '4px' }} size="small">{courseElements.map(el => (<Select.Option key={el.referenceId} value={el.referenceId}>{el.label}</Select.Option>))}</Select></div>
                        <div><Text strong style={{ fontSize: '12px' }}>Position</Text><Select value={editPositioning} onChange={(val) => setEditPositioning(val)} placeholder="Avant/Après" style={{ width: '100%', marginTop: '4px' }} size="small"><Select.Option value="BEFORE">Avant</Select.Option><Select.Option value="AFTER">Après</Select.Option></Select></div>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: '6px' }}>
                          <Button type="primary" icon={<SaveOutlined />} onClick={() => handleSaveQuiz(quiz.id)} size="small">Enregistrer</Button>
                          <Button danger onClick={() => setEditQuizId(null)} size="small">Annuler</Button>
                        </div>
                      </Space>
                    </Card>
                  ) : (
                    <Card hoverable style={{ width: '100%', marginBottom: '10px', borderRadius: '6px', border: selectedQuiz?.id === quiz.id ? '2px solid #52c41a' : '1px solid #e8e8e8', cursor: 'pointer' }} bodyStyle={{ padding: '10px' }} onClick={() => handleSelectQuiz(quiz)}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ flex: 1 }}>
                          <Title level={5} style={{ margin: 0, marginBottom: '4px', fontSize: '13px' }}>{quiz.title}</Title>
                          <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                            <Tag color="blue" style={{ fontSize: '11px', padding: '0 6px' }}>{quiz.progressPercentage || 0}%</Tag>
                            {quiz.attemptOnce && <Tag color="red" style={{ fontSize: '11px', padding: '0 6px' }}>Tentative unique</Tag>}
                            {selectedQuiz?.id === quiz.id && <Tag color="green" style={{ fontSize: '11px', padding: '0 6px' }}>Sélectionné</Tag>}
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '4px' }}>
                          <Button type="text" icon={<EditOutlined />} onClick={(e) => { e.stopPropagation(); handleEditQuizClick(quiz); }} style={{ color: '#1890ff' }} size="small" />
                          <Button type="text" danger icon={<DeleteOutlined />} onClick={(e) => { e.stopPropagation(); handleDeleteQuiz(quiz.id); }} size="small" />
                        </div>
                      </div>
                    </Card>
                  )}
                </List.Item>
              )}
            />
          )}
        </Card>

        {/* SECTION DROITE : GESTION (TABS Questions / Explication / Réponses) */}
        {selectedQuiz ? (
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <Card
              title={
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div><Title level={5} style={{ margin: 0, fontSize: '14px' }}><QuestionCircleOutlined style={{ marginRight: '4px', color: '#1890ff' }} />{selectedQuiz.title}</Title></div>
                  <Badge count={`${totalScore} pts`} style={{ backgroundColor: '#52c41a', fontSize: '11px' }} />
                </div>
              }
              style={{ borderRadius: '6px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)' }}
              bodyStyle={{ padding: '10px' }}
            >
              <Tabs activeKey={activeTab} onChange={setActiveTab} size="small">
                {/* TAB 1 : QUESTIONS */}
                <TabPane tab={<span style={{ fontSize: '13px' }}><QuestionCircleOutlined /> Questions ({questions.length})</span>} key="1">
                  <Card size="small" style={{ marginBottom: '10px', background: '#f8f9fa', border: '1px dashed #d9d9d9' }} bodyStyle={{ padding: '10px' }}>
                    <Space direction="vertical" style={{ width: '100%' }} size="small">
                      <Input placeholder="Tapez votre nouvelle question ici..." value={newQuestionText} onChange={(e) => setNewQuestionText(e.target.value)} size="small" />
                      <div style={{ display: 'flex', gap: '6px' }}>
                        <Select style={{ width: '200px' }} value={newQuestionType} onChange={(value) => setNewQuestionType(value)} size="small">
                          <Select.Option value="QCU">Choix Unique</Select.Option>
                          <Select.Option value="QCM">Choix Multiple</Select.Option>
                          <Select.Option value="DRAG_DROP">Mettre en ordre</Select.Option>
                          <Select.Option value="VRAI_FAUX">Vrai / Faux</Select.Option>
                          <Select.Option value="MATCHING">Appariement</Select.Option>
                          <Select.Option value="DRAG_DROP_ZONES">Zones à remplir</Select.Option>
                          <Select.Option value="DRAG_DROP_IMAGE">Drag & Drop Image</Select.Option>
                        </Select>
                        <Button type="primary" icon={<PlusOutlined />} onClick={handleAddQuestion} loading={loadingAddQuestion} size="small">Ajouter</Button>
                      </div>
                    </Space>
                  </Card>

                  {loadingQuestions ? (
                    <div style={{ textAlign: 'center', padding: '20px' }}><Spin /><Text style={{ display: 'block', marginTop: '8px', fontSize: '12px' }}>Chargement...</Text></div>
                  ) : (
                    <List
                      dataSource={questions}
                      renderItem={(question, index) => (
                        <List.Item style={{ border: 'none', padding: '0' }}>
                          <Card hoverable style={{ width: '100%', marginBottom: '10px', borderRadius: '6px', border: selectedQuestion?.id === question.id ? '2px solid #52c41a' : '1px solid #e8e8e8' }} bodyStyle={{ padding: '10px' }}>
                            {editQuestionId === question.id ? (
                              <Space direction="vertical" style={{ width: '100%' }} size="small">
                                <Input value={editQuestionText} onChange={(e) => setEditQuestionText(e.target.value)} placeholder="Texte" size="small" />
                                <div style={{ display: 'flex', gap: '6px' }}>
                                  <Select value={editQuestionType} onChange={(v) => setEditQuestionType(v)} style={{ width: '150px' }} size="small">
                                    <Select.Option value="QCU">Choix Unique</Select.Option>
                                    <Select.Option value="QCM">Choix Multiple</Select.Option>
                                    <Select.Option value="DRAG_DROP">Mettre en ordre</Select.Option>
                                    <Select.Option value="VRAI_FAUX">Vrai / Faux</Select.Option>
                                    <Select.Option value="MATCHING">Appariement</Select.Option>
                                    <Select.Option value="DRAG_DROP_ZONES">Zones à remplir</Select.Option>
                                    <Select.Option value="DRAG_DROP_IMAGE">Drag & Drop Image</Select.Option>
                                  </Select>
                                  <Input type="number" value={editQuestionScore} onChange={(e) => setEditQuestionScore(e.target.value)} placeholder="Score" style={{ width: '70px' }} size="small" />
                                </div>
                                {selectedQuestion?.id === question.id && renderImageOption()}
                                <div style={{ display: "flex", gap: "6px" }}>
                                  <Button type="primary" onClick={handleEditQuestion} loading={loadingSaveQuestion} size="small">Enregistrer</Button>
                                  <Button danger onClick={() => setEditQuestionId(null)} size="small">Annuler</Button>
                                </div>
                              </Space>
                            ) : (
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div style={{ flex: 1, cursor: 'pointer' }} onClick={() => handleSelectQuestion(question)}>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                                    <Badge count={index + 1} style={{ backgroundColor: '#1890ff', fontSize: '10px' }} />
                                    <Text strong style={{ fontSize: '13px' }}>{question.text}</Text>
                                  </div>
                                  <div style={{ display: 'flex', gap: '4px' }}>
                                    <Tag color="blue" style={{ fontSize: '11px', padding: '0 6px' }}>{question.questionType}</Tag>
                                    <Tag color="green" style={{ fontSize: '11px', padding: '0 6px' }}>{question.score || 0} pts</Tag>
                                    {selectedQuestion?.id === question.id && <Tag color="orange" style={{ fontSize: '11px', padding: '0 6px' }}>Sélectionnée</Tag>}
                                  </div>
                                </div>
                                <div style={{ display: "flex", gap: "4px" }}>
                                  <Button type="text" icon={<EditOutlined style={{ fontSize: '12px' }} />} onClick={(e) => { e.stopPropagation(); setEditQuestionId(question.id); setEditQuestionText(question.text); setEditQuestionScore(question.score ?? 0); setEditQuestionType(question.questionType); }} style={{ color: '#1890ff' }} size="small" />
                                  <Button type="text" danger icon={<DeleteOutlined style={{ fontSize: '12px' }} />} onClick={(e) => { e.stopPropagation(); handleDeleteQuestion(question.id); }} size="small" />
                                </div>
                              </div>
                            )}
                          </Card>
                        </List.Item>
                      )}
                    />
                  )}
                </TabPane>

                {/* TAB 2 : EXPLICATION */}
                {selectedQuestion && (
                  <TabPane tab={<span style={{ fontSize: '12px' }}><FileTextOutlined /> Explication</span>} key="2">
                    <Card title={<span style={{ fontSize: '13px' }}>Explication pour : {selectedQuestion.text}</span>} style={{ borderRadius: '6px' }} bodyStyle={{ padding: '10px' }}>
                      <Editor apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle" value={newQuestionExplanation} onEditorChange={(content) => setNewQuestionExplanation(content)} init={{ height: 250, menubar: true, plugins: "link image media table code help wordcount", toolbar: "undo redo | bold italic underline | link image | alignleft aligncenter alignright | code" }} />
                      <Button type="primary" onClick={handleUpdateExplanation} loading={loadingUpdateExplanation} style={{ marginTop: '8px' }} size="small">Enregistrer</Button>
                    </Card>
                  </TabPane>
                )}

                {/* TAB 3 : RÉPONSES */}
                {selectedQuestion && (
                  <TabPane tab={<span style={{ fontSize: '12px' }}><SettingOutlined /> Réponses {selectedQuestion && <Badge count="●" style={{ backgroundColor: '#52c41a', marginLeft: '2px' }} />}</span>} key="3">
                    <Card title={<span style={{ fontSize: '13px' }}>Configuration : {selectedQuestion.text}</span>} style={{ borderRadius: '6px' }} bodyStyle={{ padding: '10px' }}>
                      {loadingAnswers ? (
                        <div style={{ textAlign: 'center', padding: '30px' }}><Spin /><Text style={{ display: 'block', marginTop: '8px', fontSize: '12px' }}>Chargement...</Text></div>
                      ) : (
                        <>
                          {renderAnswerInput()}

                          {selectedQuestion?.questionType !== "VRAI_FAUX" &&
                            selectedQuestion?.questionType !== "MATCHING" &&
                            selectedQuestion?.questionType !== "DRAG_DROP_ZONES" &&
                            selectedQuestion?.questionType !== "DRAG_DROP_IMAGE" && (
                              <div style={{ marginTop: '12px', padding: '10px', background: '#f8f9fa', borderRadius: '6px' }}>
                                <Title level={5} style={{ fontSize: '13px' }}>Ajouter une réponse</Title>
                                <div style={{ display: 'flex', gap: '6px', marginTop: '6px' }}>
                                  <Input placeholder="Nouvelle réponse..." value={newAnswerText} onChange={(e) => setNewAnswerText(e.target.value)} size="small" style={{ flex: 1 }} />
                                  <Button type="primary" onClick={handleAddAnswer} icon={<PlusOutlined />} loading={loadingAddAnswer} size="small">Ajouter</Button>
                                </div>
                              </div>
                            )}
                        </>
                      )}
                    </Card>
                  </TabPane>
                )}
              </Tabs>
            </Card>
          </div>
        ) : (
          <Card style={{ borderRadius: '6px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)', textAlign: 'center', minHeight: '250px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div>
              <BookOutlined style={{ fontSize: '40px', color: '#d9d9d9', marginBottom: '10px' }} />
              <Title level={4} type="secondary" style={{ fontSize: '15px' }}>Sélectionnez une évaluation</Title>
              <Text type="secondary" style={{ fontSize: '13px' }}>Choisissez une évaluation dans la liste</Text>
            </div>
          </Card>
        )}
      </div>

      {/* MODAL D'AJOUT */}
      <Modal
        title={<div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><PlusCircleOutlined style={{ color: '#1890ff', fontSize: '16px' }} /><span style={{ fontSize: '15px' }}>Créer une nouvelle évaluation</span></div>}
        open={isQuizModalVisible}
        onCancel={() => { setIsQuizModalVisible(false); setNewQuizTitle(""); setAttemptOnce(false); form.resetFields(); }}
        onOk={handleAddQuiz}
        okText="Créer" cancelText="Annuler" width={500}
        okButtonProps={{ size: 'small' }} cancelButtonProps={{ size: 'small' }}
      >
        <Form form={form} layout="vertical" style={{ marginTop: '12px' }}>
          <Form.Item label={<span style={{ fontSize: '12px' }}>Titre de l'évaluation</span>} required>
            <Input placeholder="Titre de l'évaluation" value={newQuizTitle} onChange={(e) => setNewQuizTitle(e.target.value)} size="small" />
          </Form.Item>
          <Form.Item label={<span style={{ fontSize: '12px' }}>Options</span>}>
            <Checkbox checked={attemptOnce} onChange={(e) => setAttemptOnce(e.target.checked)} style={{ fontSize: '12px' }}>Tentative unique</Checkbox>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );

  return (
    <>
      {showInPage && renderEvaluationManagement()}
      {!showInPage && (
        <>
          <Button onClick={() => setIsModalVisible(true)} size="small">Gérer les Évaluations</Button>
          <Modal title="Gestion des Évaluations" open={isModalVisible} onCancel={() => setIsModalVisible(false)} footer={<Button onClick={() => setIsModalVisible(false)} size="small">Fermer</Button>} width="95%" style={{ top: 20 }}>
            {renderEvaluationManagement()}
          </Modal>
        </>
      )}
    </>
  );
};

export default EvaluationsManager;